import { isRef as ue, ref as se, watch as $e, defineComponent as K, toRef as qe, reactive as Fs, useAttrs as kr, provide as Bs, createElementBlock as q, openBlock as D, renderSlot as wn, inject as Ar, createElementVNode as $, withModifiers as Z, withKeys as Wt, createBlock as Re, createVNode as te, useSlots as Hs, computed as pe, defineAsyncComponent as ht, normalizeClass as Et, createCommentVNode as _t, resolveDynamicComponent as qs, unref as Oe, toDisplayString as _n, watchEffect as Ws, withCtx as Le, createTextVNode as mt, Fragment as nn, renderList as rn, onBeforeUnmount as zs, TransitionGroup as Ys } from "vue";
import Dn from "@leaflink/stash/Button.vue";
import Vs from "@leaflink/stash/Icon.vue";
import Gs from "@leaflink/stash/Loading.vue";
import Ks from "@leaflink/stash/Tab.vue";
import Js from "@leaflink/stash/Tabs.vue";
import Xs from "@leaflink/stash/Badge.vue";
function Pr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var xr = { exports: {} };
/*!
 * EventEmitter2
 * https://github.com/hij1nx/EventEmitter2
 *
 * Copyright (c) 2013 hij1nx
 * Licensed under the MIT license.
 */
(function(e, t) {
  (function(n) {
    var r = Object.hasOwnProperty, s = Array.isArray ? Array.isArray : function(f) {
      return Object.prototype.toString.call(f) === "[object Array]";
    }, i = 10, o = typeof process == "object" && typeof process.nextTick == "function", a = typeof Symbol == "function", u = typeof Reflect == "object", l = typeof setImmediate == "function", d = l ? setImmediate : setTimeout, h = a ? u && typeof Reflect.ownKeys == "function" ? Reflect.ownKeys : function(c) {
      var f = Object.getOwnPropertyNames(c);
      return f.push.apply(f, Object.getOwnPropertySymbols(c)), f;
    } : Object.keys;
    function w() {
      this._events = {}, this._conf && R.call(this, this._conf);
    }
    function R(c) {
      c && (this._conf = c, c.delimiter && (this.delimiter = c.delimiter), c.maxListeners !== n && (this._maxListeners = c.maxListeners), c.wildcard && (this.wildcard = c.wildcard), c.newListener && (this._newListener = c.newListener), c.removeListener && (this._removeListener = c.removeListener), c.verboseMemoryLeak && (this.verboseMemoryLeak = c.verboseMemoryLeak), c.ignoreErrors && (this.ignoreErrors = c.ignoreErrors), this.wildcard && (this.listenerTree = {}));
    }
    function _(c, f) {
      var m = "(node) warning: possible EventEmitter memory leak detected. " + c + " listeners added. Use emitter.setMaxListeners() to increase limit.";
      if (this.verboseMemoryLeak && (m += " Event name: " + f + "."), typeof process < "u" && process.emitWarning) {
        var p = new Error(m);
        p.name = "MaxListenersExceededWarning", p.emitter = this, p.count = c, process.emitWarning(p);
      } else
        console.error(m), console.trace && console.trace();
    }
    var b = function(c, f, m) {
      var p = arguments.length;
      switch (p) {
        case 0:
          return [];
        case 1:
          return [c];
        case 2:
          return [c, f];
        case 3:
          return [c, f, m];
        default:
          for (var y = new Array(p); p--; )
            y[p] = arguments[p];
          return y;
      }
    };
    function O(c, f) {
      for (var m = {}, p, y = c.length, v = 0, T = 0; T < y; T++)
        p = c[T], m[p] = T < v ? f[T] : n;
      return m;
    }
    function P(c, f, m) {
      this._emitter = c, this._target = f, this._listeners = {}, this._listenersCount = 0;
      var p, y;
      if ((m.on || m.off) && (p = m.on, y = m.off), f.addEventListener ? (p = f.addEventListener, y = f.removeEventListener) : f.addListener ? (p = f.addListener, y = f.removeListener) : f.on && (p = f.on, y = f.off), !p && !y)
        throw Error("target does not implement any known event API");
      if (typeof p != "function")
        throw TypeError("on method must be a function");
      if (typeof y != "function")
        throw TypeError("off method must be a function");
      this._on = p, this._off = y;
      var v = c._observers;
      v ? v.push(this) : c._observers = [this];
    }
    Object.assign(P.prototype, {
      subscribe: function(c, f, m) {
        var p = this, y = this._target, v = this._emitter, T = this._listeners, C = function() {
          var E = b.apply(null, arguments), S = {
            data: E,
            name: f,
            original: c
          };
          if (m) {
            var k = m.call(y, S);
            k !== !1 && v.emit.apply(v, [S.name].concat(E));
            return;
          }
          v.emit.apply(v, [f].concat(E));
        };
        if (T[c])
          throw Error("Event '" + c + "' is already listening");
        this._listenersCount++, v._newListener && v._removeListener && !p._onNewListener ? (this._onNewListener = function(E) {
          E === f && T[c] === null && (T[c] = C, p._on.call(y, c, C));
        }, v.on("newListener", this._onNewListener), this._onRemoveListener = function(E) {
          E === f && !v.hasListeners(E) && T[c] && (T[c] = null, p._off.call(y, c, C));
        }, T[c] = null, v.on("removeListener", this._onRemoveListener)) : (T[c] = C, p._on.call(y, c, C));
      },
      unsubscribe: function(c) {
        var f = this, m = this._listeners, p = this._emitter, y, v, T = this._off, C = this._target, E;
        if (c && typeof c != "string")
          throw TypeError("event must be a string");
        function S() {
          f._onNewListener && (p.off("newListener", f._onNewListener), p.off("removeListener", f._onRemoveListener), f._onNewListener = null, f._onRemoveListener = null);
          var k = xe.call(p, f);
          p._observers.splice(k, 1);
        }
        if (c) {
          if (y = m[c], !y) return;
          T.call(C, c, y), delete m[c], --this._listenersCount || S();
        } else {
          for (v = h(m), E = v.length; E-- > 0; )
            c = v[E], T.call(C, c, m[c]);
          this._listeners = {}, this._listenersCount = 0, S();
        }
      }
    });
    function A(c, f, m, p) {
      var y = Object.assign({}, f);
      if (!c) return y;
      if (typeof c != "object")
        throw TypeError("options must be an object");
      var v = Object.keys(c), T = v.length, C, E, S;
      function k(I) {
        throw Error('Invalid "' + C + '" option value' + (I ? ". Reason: " + I : ""));
      }
      for (var Y = 0; Y < T; Y++) {
        if (C = v[Y], !r.call(f, C))
          throw Error('Unknown "' + C + '" option');
        E = c[C], E !== n && (S = m[C], y[C] = S ? S(E, k) : E);
      }
      return y;
    }
    function x(c, f) {
      return (typeof c != "function" || !c.hasOwnProperty("prototype")) && f("value must be a constructor"), c;
    }
    function W(c) {
      var f = "value must be type of " + c.join("|"), m = c.length, p = c[0], y = c[1];
      return m === 1 ? function(v, T) {
        if (typeof v === p)
          return v;
        T(f);
      } : m === 2 ? function(v, T) {
        var C = typeof v;
        if (C === p || C === y) return v;
        T(f);
      } : function(v, T) {
        for (var C = typeof v, E = m; E-- > 0; )
          if (C === c[E]) return v;
        T(f);
      };
    }
    var F = W(["function"]), oe = W(["object", "function"]);
    function ae(c, f, m) {
      var p, y, v = 0, T, C = new c(function(E, S, k) {
        m = A(m, {
          timeout: 0,
          overload: !1
        }, {
          timeout: function(H, J) {
            return H *= 1, (typeof H != "number" || H < 0 || !Number.isFinite(H)) && J("timeout must be a positive number"), H;
          }
        }), p = !m.overload && typeof c.prototype.cancel == "function" && typeof k == "function";
        function Y() {
          y && (y = null), v && (clearTimeout(v), v = 0);
        }
        var I = function(H) {
          Y(), E(H);
        }, M = function(H) {
          Y(), S(H);
        };
        p ? f(I, M, k) : (y = [function(H) {
          M(H || Error("canceled"));
        }], f(I, M, function(H) {
          if (T)
            throw Error("Unable to subscribe on cancel event asynchronously");
          if (typeof H != "function")
            throw TypeError("onCancel callback must be a function");
          y.push(H);
        }), T = !0), m.timeout > 0 && (v = setTimeout(function() {
          var H = Error("timeout");
          H.code = "ETIMEDOUT", v = 0, C.cancel(H), S(H);
        }, m.timeout));
      });
      return p || (C.cancel = function(E) {
        if (y) {
          for (var S = y.length, k = 1; k < S; k++)
            y[k](E);
          y[0](E), y = null;
        }
      }), C;
    }
    function xe(c) {
      var f = this._observers;
      if (!f)
        return -1;
      for (var m = f.length, p = 0; p < m; p++)
        if (f[p]._target === c) return p;
      return -1;
    }
    function B(c, f, m, p, y) {
      if (!m)
        return null;
      if (p === 0) {
        var v = typeof f;
        if (v === "string") {
          var T, C, E = 0, S = 0, k = this.delimiter, Y = k.length;
          if ((C = f.indexOf(k)) !== -1) {
            T = new Array(5);
            do
              T[E++] = f.slice(S, C), S = C + Y;
            while ((C = f.indexOf(k, S)) !== -1);
            T[E++] = f.slice(S), f = T, y = E;
          } else
            f = [f], y = 1;
        } else v === "object" ? y = f.length : (f = [f], y = 1);
      }
      var I = null, M, H, J, Bt, Ht, Ge = f[p], qt = f[p + 1], de, X;
      if (p === y)
        m._listeners && (typeof m._listeners == "function" ? (c && c.push(m._listeners), I = [m]) : (c && c.push.apply(c, m._listeners), I = [m]));
      else if (Ge === "*") {
        for (de = h(m), C = de.length; C-- > 0; )
          M = de[C], M !== "_listeners" && (X = B(c, f, m[M], p + 1, y), X && (I ? I.push.apply(I, X) : I = X));
        return I;
      } else if (Ge === "**") {
        for (Ht = p + 1 === y || p + 2 === y && qt === "*", Ht && m._listeners && (I = B(c, f, m, y, y)), de = h(m), C = de.length; C-- > 0; )
          M = de[C], M !== "_listeners" && (M === "*" || M === "**" ? (m[M]._listeners && !Ht && (X = B(c, f, m[M], y, y), X && (I ? I.push.apply(I, X) : I = X)), X = B(c, f, m[M], p, y)) : M === qt ? X = B(c, f, m[M], p + 2, y) : X = B(c, f, m[M], p, y), X && (I ? I.push.apply(I, X) : I = X));
        return I;
      } else m[Ge] && (I = B(c, f, m[Ge], p + 1, y));
      if (H = m["*"], H && B(c, f, H, p + 1, y), J = m["**"], J)
        if (p < y)
          for (J._listeners && B(c, f, J, y, y), de = h(J), C = de.length; C-- > 0; )
            M = de[C], M !== "_listeners" && (M === qt ? B(c, f, J[M], p + 2, y) : M === Ge ? B(c, f, J[M], p + 1, y) : (Bt = {}, Bt[M] = J[M], B(c, f, { "**": Bt }, p + 1, y)));
        else J._listeners ? B(c, f, J, y, y) : J["*"] && J["*"]._listeners && B(c, f, J["*"], y, y);
      return I;
    }
    function js(c, f, m) {
      var p = 0, y = 0, v, T = this.delimiter, C = T.length, E;
      if (typeof c == "string")
        if ((v = c.indexOf(T)) !== -1) {
          E = new Array(5);
          do
            E[p++] = c.slice(y, v), y = v + C;
          while ((v = c.indexOf(T, y)) !== -1);
          E[p++] = c.slice(y);
        } else
          E = [c], p = 1;
      else
        E = c, p = c.length;
      if (p > 1) {
        for (v = 0; v + 1 < p; v++)
          if (E[v] === "**" && E[v + 1] === "**")
            return;
      }
      var S = this.listenerTree, k;
      for (v = 0; v < p; v++)
        if (k = E[v], S = S[k] || (S[k] = {}), v === p - 1)
          return S._listeners ? (typeof S._listeners == "function" && (S._listeners = [S._listeners]), m ? S._listeners.unshift(f) : S._listeners.push(f), !S._listeners.warned && this._maxListeners > 0 && S._listeners.length > this._maxListeners && (S._listeners.warned = !0, _.call(this, S._listeners.length, k))) : S._listeners = f, !0;
      return !0;
    }
    function Nn(c, f, m, p) {
      for (var y = h(c), v = y.length, T, C, E, S = c._listeners, k; v-- > 0; )
        C = y[v], T = c[C], C === "_listeners" ? E = m : E = m ? m.concat(C) : [C], k = p || typeof C == "symbol", S && f.push(k ? E : E.join(this.delimiter)), typeof T == "object" && Nn.call(this, T, f, E, k);
      return f;
    }
    function Ut(c) {
      for (var f = h(c), m = f.length, p, y, v; m-- > 0; )
        y = f[m], p = c[y], p && (v = !0, y !== "_listeners" && !Ut(p) && delete c[y]);
      return v;
    }
    function Ln(c, f, m) {
      this.emitter = c, this.event = f, this.listener = m;
    }
    Ln.prototype.off = function() {
      return this.emitter.off(this.event, this.listener), this;
    };
    function $s(c, f, m) {
      if (m === !0)
        y = !0;
      else if (m === !1)
        p = !0;
      else {
        if (!m || typeof m != "object")
          throw TypeError("options should be an object or true");
        var p = m.async, y = m.promisify, v = m.nextTick, T = m.objectify;
      }
      if (p || v || y) {
        var C = f, E = f._origin || f;
        if (v && !o)
          throw Error("process.nextTick is not supported");
        y === n && (y = f.constructor.name === "AsyncFunction"), f = function() {
          var S = arguments, k = this, Y = this.event;
          return y ? v ? Promise.resolve() : new Promise(function(I) {
            d(I);
          }).then(function() {
            return k.event = Y, C.apply(k, S);
          }) : (v ? process.nextTick : d)(function() {
            k.event = Y, C.apply(k, S);
          });
        }, f._async = !0, f._origin = E;
      }
      return [f, T ? new Ln(this, c, f) : this];
    }
    function L(c) {
      this._events = {}, this._newListener = !1, this._removeListener = !1, this.verboseMemoryLeak = !1, R.call(this, c);
    }
    L.EventEmitter2 = L, L.prototype.listenTo = function(c, f, m) {
      if (typeof c != "object")
        throw TypeError("target musts be an object");
      var p = this;
      m = A(m, {
        on: n,
        off: n,
        reducers: n
      }, {
        on: F,
        off: F,
        reducers: oe
      });
      function y(v) {
        if (typeof v != "object")
          throw TypeError("events must be an object");
        var T = m.reducers, C = xe.call(p, c), E;
        C === -1 ? E = new P(p, c, m) : E = p._observers[C];
        for (var S = h(v), k = S.length, Y, I = typeof T == "function", M = 0; M < k; M++)
          Y = S[M], E.subscribe(
            Y,
            v[Y] || Y,
            I ? T : T && T[Y]
          );
      }
      return s(f) ? y(O(f)) : y(typeof f == "string" ? O(f.split(/\s+/)) : f), this;
    }, L.prototype.stopListeningTo = function(c, f) {
      var m = this._observers;
      if (!m)
        return !1;
      var p = m.length, y, v = !1;
      if (c && typeof c != "object")
        throw TypeError("target should be an object");
      for (; p-- > 0; )
        y = m[p], (!c || y._target === c) && (y.unsubscribe(f), v = !0);
      return v;
    }, L.prototype.delimiter = ".", L.prototype.setMaxListeners = function(c) {
      c !== n && (this._maxListeners = c, this._conf || (this._conf = {}), this._conf.maxListeners = c);
    }, L.prototype.getMaxListeners = function() {
      return this._maxListeners;
    }, L.prototype.event = "", L.prototype.once = function(c, f, m) {
      return this._once(c, f, !1, m);
    }, L.prototype.prependOnceListener = function(c, f, m) {
      return this._once(c, f, !0, m);
    }, L.prototype._once = function(c, f, m, p) {
      return this._many(c, 1, f, m, p);
    }, L.prototype.many = function(c, f, m, p) {
      return this._many(c, f, m, !1, p);
    }, L.prototype.prependMany = function(c, f, m, p) {
      return this._many(c, f, m, !0, p);
    }, L.prototype._many = function(c, f, m, p, y) {
      var v = this;
      if (typeof m != "function")
        throw new Error("many only accepts instances of Function");
      function T() {
        return --f === 0 && v.off(c, T), m.apply(this, arguments);
      }
      return T._origin = m, this._on(c, T, p, y);
    }, L.prototype.emit = function() {
      if (!this._events && !this._all)
        return !1;
      this._events || w.call(this);
      var c = arguments[0], f, m = this.wildcard, p, y, v, T, C;
      if (c === "newListener" && !this._newListener && !this._events.newListener)
        return !1;
      if (m && (f = c, c !== "newListener" && c !== "removeListener" && typeof c == "object")) {
        if (y = c.length, a) {
          for (v = 0; v < y; v++)
            if (typeof c[v] == "symbol") {
              C = !0;
              break;
            }
        }
        C || (c = c.join(this.delimiter));
      }
      var E = arguments.length, S;
      if (this._all && this._all.length)
        for (S = this._all.slice(), v = 0, y = S.length; v < y; v++)
          switch (this.event = c, E) {
            case 1:
              S[v].call(this, c);
              break;
            case 2:
              S[v].call(this, c, arguments[1]);
              break;
            case 3:
              S[v].call(this, c, arguments[1], arguments[2]);
              break;
            default:
              S[v].apply(this, arguments);
          }
      if (m)
        S = [], B.call(this, S, f, this.listenerTree, 0, y);
      else if (S = this._events[c], typeof S == "function") {
        switch (this.event = c, E) {
          case 1:
            S.call(this);
            break;
          case 2:
            S.call(this, arguments[1]);
            break;
          case 3:
            S.call(this, arguments[1], arguments[2]);
            break;
          default:
            for (p = new Array(E - 1), T = 1; T < E; T++) p[T - 1] = arguments[T];
            S.apply(this, p);
        }
        return !0;
      } else S && (S = S.slice());
      if (S && S.length) {
        if (E > 3)
          for (p = new Array(E - 1), T = 1; T < E; T++) p[T - 1] = arguments[T];
        for (v = 0, y = S.length; v < y; v++)
          switch (this.event = c, E) {
            case 1:
              S[v].call(this);
              break;
            case 2:
              S[v].call(this, arguments[1]);
              break;
            case 3:
              S[v].call(this, arguments[1], arguments[2]);
              break;
            default:
              S[v].apply(this, p);
          }
        return !0;
      } else if (!this.ignoreErrors && !this._all && c === "error")
        throw arguments[1] instanceof Error ? arguments[1] : new Error("Uncaught, unspecified 'error' event.");
      return !!this._all;
    }, L.prototype.emitAsync = function() {
      if (!this._events && !this._all)
        return !1;
      this._events || w.call(this);
      var c = arguments[0], f = this.wildcard, m, p, y, v, T, C;
      if (c === "newListener" && !this._newListener && !this._events.newListener)
        return Promise.resolve([!1]);
      if (f && (m = c, c !== "newListener" && c !== "removeListener" && typeof c == "object")) {
        if (v = c.length, a) {
          for (T = 0; T < v; T++)
            if (typeof c[T] == "symbol") {
              p = !0;
              break;
            }
        }
        p || (c = c.join(this.delimiter));
      }
      var E = [], S = arguments.length, k;
      if (this._all)
        for (T = 0, v = this._all.length; T < v; T++)
          switch (this.event = c, S) {
            case 1:
              E.push(this._all[T].call(this, c));
              break;
            case 2:
              E.push(this._all[T].call(this, c, arguments[1]));
              break;
            case 3:
              E.push(this._all[T].call(this, c, arguments[1], arguments[2]));
              break;
            default:
              E.push(this._all[T].apply(this, arguments));
          }
      if (f ? (k = [], B.call(this, k, m, this.listenerTree, 0)) : k = this._events[c], typeof k == "function")
        switch (this.event = c, S) {
          case 1:
            E.push(k.call(this));
            break;
          case 2:
            E.push(k.call(this, arguments[1]));
            break;
          case 3:
            E.push(k.call(this, arguments[1], arguments[2]));
            break;
          default:
            for (y = new Array(S - 1), C = 1; C < S; C++) y[C - 1] = arguments[C];
            E.push(k.apply(this, y));
        }
      else if (k && k.length) {
        if (k = k.slice(), S > 3)
          for (y = new Array(S - 1), C = 1; C < S; C++) y[C - 1] = arguments[C];
        for (T = 0, v = k.length; T < v; T++)
          switch (this.event = c, S) {
            case 1:
              E.push(k[T].call(this));
              break;
            case 2:
              E.push(k[T].call(this, arguments[1]));
              break;
            case 3:
              E.push(k[T].call(this, arguments[1], arguments[2]));
              break;
            default:
              E.push(k[T].apply(this, y));
          }
      } else if (!this.ignoreErrors && !this._all && c === "error")
        return arguments[1] instanceof Error ? Promise.reject(arguments[1]) : Promise.reject("Uncaught, unspecified 'error' event.");
      return Promise.all(E);
    }, L.prototype.on = function(c, f, m) {
      return this._on(c, f, !1, m);
    }, L.prototype.prependListener = function(c, f, m) {
      return this._on(c, f, !0, m);
    }, L.prototype.onAny = function(c) {
      return this._onAny(c, !1);
    }, L.prototype.prependAny = function(c) {
      return this._onAny(c, !0);
    }, L.prototype.addListener = L.prototype.on, L.prototype._onAny = function(c, f) {
      if (typeof c != "function")
        throw new Error("onAny only accepts instances of Function");
      return this._all || (this._all = []), f ? this._all.unshift(c) : this._all.push(c), this;
    }, L.prototype._on = function(c, f, m, p) {
      if (typeof c == "function")
        return this._onAny(c, f), this;
      if (typeof f != "function")
        throw new Error("on only accepts instances of Function");
      this._events || w.call(this);
      var y = this, v;
      return p !== n && (v = $s.call(this, c, f, p), f = v[0], y = v[1]), this._newListener && this.emit("newListener", c, f), this.wildcard ? (js.call(this, c, f, m), y) : (this._events[c] ? (typeof this._events[c] == "function" && (this._events[c] = [this._events[c]]), m ? this._events[c].unshift(f) : this._events[c].push(f), !this._events[c].warned && this._maxListeners > 0 && this._events[c].length > this._maxListeners && (this._events[c].warned = !0, _.call(this, this._events[c].length, c))) : this._events[c] = f, y);
    }, L.prototype.off = function(c, f) {
      if (typeof f != "function")
        throw new Error("removeListener only takes instances of Function");
      var m, p = [];
      if (this.wildcard) {
        var y = typeof c == "string" ? c.split(this.delimiter) : c.slice();
        if (p = B.call(this, null, y, this.listenerTree, 0), !p) return this;
      } else {
        if (!this._events[c]) return this;
        m = this._events[c], p.push({ _listeners: m });
      }
      for (var v = 0; v < p.length; v++) {
        var T = p[v];
        if (m = T._listeners, s(m)) {
          for (var C = -1, E = 0, S = m.length; E < S; E++)
            if (m[E] === f || m[E].listener && m[E].listener === f || m[E]._origin && m[E]._origin === f) {
              C = E;
              break;
            }
          if (C < 0)
            continue;
          return this.wildcard ? T._listeners.splice(C, 1) : this._events[c].splice(C, 1), m.length === 0 && (this.wildcard ? delete T._listeners : delete this._events[c]), this._removeListener && this.emit("removeListener", c, f), this;
        } else (m === f || m.listener && m.listener === f || m._origin && m._origin === f) && (this.wildcard ? delete T._listeners : delete this._events[c], this._removeListener && this.emit("removeListener", c, f));
      }
      return this.listenerTree && Ut(this.listenerTree), this;
    }, L.prototype.offAny = function(c) {
      var f = 0, m = 0, p;
      if (c && this._all && this._all.length > 0) {
        for (p = this._all, f = 0, m = p.length; f < m; f++)
          if (c === p[f])
            return p.splice(f, 1), this._removeListener && this.emit("removeListenerAny", c), this;
      } else {
        if (p = this._all, this._removeListener)
          for (f = 0, m = p.length; f < m; f++)
            this.emit("removeListenerAny", p[f]);
        this._all = [];
      }
      return this;
    }, L.prototype.removeListener = L.prototype.off, L.prototype.removeAllListeners = function(c) {
      if (c === n)
        return !this._events || w.call(this), this;
      if (this.wildcard) {
        var f = B.call(this, null, c, this.listenerTree, 0), m, p;
        if (!f) return this;
        for (p = 0; p < f.length; p++)
          m = f[p], m._listeners = null;
        this.listenerTree && Ut(this.listenerTree);
      } else this._events && (this._events[c] = null);
      return this;
    }, L.prototype.listeners = function(c) {
      var f = this._events, m, p, y, v, T;
      if (c === n) {
        if (this.wildcard)
          throw Error("event name required for wildcard emitter");
        if (!f)
          return [];
        for (m = h(f), v = m.length, y = []; v-- > 0; )
          p = f[m[v]], typeof p == "function" ? y.push(p) : y.push.apply(y, p);
        return y;
      } else {
        if (this.wildcard) {
          if (T = this.listenerTree, !T) return [];
          var C = [], E = typeof c == "string" ? c.split(this.delimiter) : c.slice();
          return B.call(this, C, E, T, 0), C;
        }
        return f ? (p = f[c], p ? typeof p == "function" ? [p] : p : []) : [];
      }
    }, L.prototype.eventNames = function(c) {
      var f = this._events;
      return this.wildcard ? Nn.call(this, this.listenerTree, [], null, c) : f ? h(f) : [];
    }, L.prototype.listenerCount = function(c) {
      return this.listeners(c).length;
    }, L.prototype.hasListeners = function(c) {
      if (this.wildcard) {
        var f = [], m = typeof c == "string" ? c.split(this.delimiter) : c.slice();
        return B.call(this, f, m, this.listenerTree, 0), f.length > 0;
      }
      var p = this._events, y = this._all;
      return !!(y && y.length || p && (c === n ? h(p).length : p[c]));
    }, L.prototype.listenersAny = function() {
      return this._all ? this._all : [];
    }, L.prototype.waitFor = function(c, f) {
      var m = this, p = typeof f;
      return p === "number" ? f = { timeout: f } : p === "function" && (f = { filter: f }), f = A(f, {
        timeout: 0,
        filter: n,
        handleError: !1,
        Promise,
        overload: !1
      }, {
        filter: F,
        Promise: x
      }), ae(f.Promise, function(y, v, T) {
        function C() {
          var E = f.filter;
          if (!(E && !E.apply(m, arguments)))
            if (m.off(c, C), f.handleError) {
              var S = arguments[0];
              S ? v(S) : y(b.apply(null, arguments).slice(1));
            } else
              y(b.apply(null, arguments));
        }
        T(function() {
          m.off(c, C);
        }), m._on(c, C, !1);
      }, {
        timeout: f.timeout,
        overload: f.overload
      });
    };
    function Us(c, f, m) {
      m = A(m, {
        Promise,
        timeout: 0,
        overload: !1
      }, {
        Promise: x
      });
      var p = m.Promise;
      return ae(p, function(y, v, T) {
        var C;
        if (typeof c.addEventListener == "function") {
          C = function() {
            y(b.apply(null, arguments));
          }, T(function() {
            c.removeEventListener(f, C);
          }), c.addEventListener(
            f,
            C,
            { once: !0 }
          );
          return;
        }
        var E = function() {
          S && c.removeListener("error", S), y(b.apply(null, arguments));
        }, S;
        f !== "error" && (S = function(k) {
          c.removeListener(f, E), v(k);
        }, c.once("error", S)), T(function() {
          S && c.removeListener("error", S), c.removeListener(f, E);
        }), c.once(f, E);
      }, {
        timeout: m.timeout,
        overload: m.overload
      });
    }
    var Ft = L.prototype;
    Object.defineProperties(L, {
      defaultMaxListeners: {
        get: function() {
          return Ft._maxListeners;
        },
        set: function(c) {
          if (typeof c != "number" || c < 0 || Number.isNaN(c))
            throw TypeError("n must be a non-negative number");
          Ft._maxListeners = c;
        },
        enumerable: !0
      },
      once: {
        value: Us,
        writable: !0,
        configurable: !0
      }
    }), Object.defineProperties(Ft, {
      _maxListeners: {
        value: i,
        writable: !0,
        configurable: !0
      },
      _observers: { value: null, writable: !0, configurable: !0 }
    }), e.exports = L;
  })();
})(xr);
var Zs = xr.exports;
const Qs = /* @__PURE__ */ Pr(Zs);
var Ce = /* @__PURE__ */ ((e) => (e.loading = "loading", e.fetchMore = "fetchMore", e.ready = "ready", e.error = "error", e))(Ce || {});
function ei(e) {
  return [
    "loading",
    "fetchMore"
    /* fetchMore */
  ].includes(
    e
  );
}
function ti(e) {
  let t;
  const n = /* @__PURE__ */ new Set(), r = (l, d) => {
    const h = typeof l == "function" ? l(t) : l;
    if (h !== t) {
      const w = t;
      t = d ? h : Object.assign({}, t, h), n.forEach((R) => R(t, w));
    }
  }, s = () => t, i = (l, d = s, h = Object.is) => {
    console.warn("[DEPRECATED] Please use `subscribeWithSelector` middleware");
    let w = d(t);
    function R() {
      const _ = d(t);
      if (!h(w, _)) {
        const b = w;
        l(w = _, b);
      }
    }
    return n.add(R), () => n.delete(R);
  }, u = { setState: r, getState: s, subscribe: (l, d, h) => d || h ? i(l, d, h) : (n.add(l), () => n.delete(l)), destroy: () => n.clear() };
  return t = e(r, s, u), u;
}
function ni(e) {
  const t = {}, n = [];
  return e.reduce((r, s) => t[s.id] ? r : (t[s.id] = !0, [...r, s]), n);
}
function ri(e) {
  return e.sort((t, n) => new Date(n.inserted_at).getTime() - new Date(t.inserted_at).getTime());
}
function si(e) {
  const t = ni(e);
  return ri(t);
}
const ii = {
  shouldSetPage: !0,
  shouldAppend: !1
}, zt = {
  items: [],
  metadata: {
    total_count: 0,
    unread_count: 0,
    unseen_count: 0
  },
  pageInfo: {
    before: null,
    after: null,
    page_size: 50
  }
};
function oi() {
  return ti((e) => ({
    // Keeps track of all of the items loaded
    ...zt,
    // The network status indicates what's happening with the request
    networkStatus: Ce.ready,
    loading: !1,
    setNetworkStatus: (t) => e(() => ({
      networkStatus: t,
      loading: t === Ce.loading
    })),
    setResult: ({ entries: t, meta: n, page_info: r }, s = ii) => e((i) => ({
      items: s.shouldAppend ? si(i.items.concat(t)) : t,
      metadata: n,
      pageInfo: s.shouldSetPage ? r : i.pageInfo,
      loading: !1,
      networkStatus: Ce.ready
    })),
    setMetadata: (t) => e(() => ({ metadata: t })),
    resetStore: (t = zt.metadata) => e(() => ({ ...zt, metadata: t })),
    setItemAttrs: (t, n) => {
      const r = t.reduce(
        (s, i) => ({ ...s, [i]: n }),
        {}
      );
      return e((s) => ({ items: s.items.map((i) => r[i.id] ? { ...i, ...r[i.id] } : i) }));
    }
  }));
}
var ai = Object.defineProperty, ci = (e, t, n) => t in e ? ai(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, be = (e, t, n) => (ci(e, typeof t != "symbol" ? t + "" : t, n), n);
const ui = {
  archived: "exclude"
}, li = 2e3;
class fi {
  constructor(t, n, r) {
    be(this, "userFeedId"), be(this, "channel"), be(this, "broadcaster"), be(this, "defaultOptions"), be(this, "broadcastChannel"), be(this, "disconnectTimer", null), be(this, "hasSubscribedToRealTimeUpdates", !1), be(this, "store"), this.knock = t, this.feedId = n, this.feedId = n, this.userFeedId = this.buildUserFeedId(), this.store = oi(), this.broadcaster = new Qs({ wildcard: !0, delimiter: "." }), this.defaultOptions = { ...ui, ...r }, this.knock.log(`[Feed] Initialized a feed on channel ${n}`), this.initializeRealtimeConnection(), this.setupBroadcastChannel();
  }
  /**
   * Used to reinitialize a current feed instance, which is useful when reauthenticating users
   */
  reinitialize() {
    this.userFeedId = this.buildUserFeedId(), this.initializeRealtimeConnection(), this.setupBroadcastChannel();
  }
  /**
   * Cleans up a feed instance by destroying the store and disconnecting
   * an open socket connection.
   */
  teardown() {
    this.knock.log("[Feed] Tearing down feed instance"), this.channel && (this.channel.leave(), this.channel.off("new-message")), this.disconnectTimer && (clearTimeout(this.disconnectTimer), this.disconnectTimer = null), this.broadcastChannel && this.broadcastChannel.close();
  }
  /** Tears down an instance and removes it entirely from the feed manager */
  dispose() {
    this.knock.log("[Feed] Disposing of feed instance"), this.teardown(), this.broadcaster.removeAllListeners(), this.knock.feeds.removeInstance(this);
  }
  /*
    Initializes a real-time connection to Knock, connecting the websocket for the
    current ApiClient instance if the socket is not already connected.
  */
  listenForUpdates() {
    this.knock.log("[Feed] Connecting to real-time service"), this.hasSubscribedToRealTimeUpdates = !0;
    const t = this.knock.client().socket;
    t && !t.isConnected() && t.connect(), this.channel && ["closed", "errored"].includes(this.channel.state) && this.channel.join();
  }
  /* Binds a handler to be invoked when event occurs */
  on(t, n) {
    this.broadcaster.on(t, n);
  }
  off(t, n) {
    this.broadcaster.off(t, n);
  }
  getState() {
    return this.store.getState();
  }
  async markAsSeen(t) {
    const n = (/* @__PURE__ */ new Date()).toISOString();
    return this.optimisticallyPerformStatusUpdate(
      t,
      "seen",
      { seen_at: n },
      "unseen_count"
    ), this.makeStatusUpdate(t, "seen");
  }
  async markAllAsSeen() {
    const { getState: t, setState: n } = this.store, { metadata: r, items: s } = t();
    if (this.defaultOptions.status === "unseen")
      n(
        (o) => o.resetStore({
          ...r,
          total_count: 0,
          unseen_count: 0
        })
      );
    else {
      n((u) => u.setMetadata({ ...r, unseen_count: 0 }));
      const o = { seen_at: (/* @__PURE__ */ new Date()).toISOString() }, a = s.map((u) => u.id);
      n((u) => u.setItemAttrs(a, o));
    }
    const i = await this.makeBulkStatusUpdate("seen");
    return this.broadcaster.emit("items:all_seen", { items: s }), this.broadcastOverChannel("items:all_seen", { items: s }), i;
  }
  async markAsUnseen(t) {
    return this.optimisticallyPerformStatusUpdate(
      t,
      "unseen",
      { seen_at: null },
      "unseen_count"
    ), this.makeStatusUpdate(t, "unseen");
  }
  async markAsRead(t) {
    const n = (/* @__PURE__ */ new Date()).toISOString();
    return this.optimisticallyPerformStatusUpdate(
      t,
      "read",
      { read_at: n },
      "unread_count"
    ), this.makeStatusUpdate(t, "read");
  }
  async markAllAsRead() {
    const { getState: t, setState: n } = this.store, { metadata: r, items: s } = t();
    if (this.defaultOptions.status === "unread")
      n(
        (o) => o.resetStore({
          ...r,
          total_count: 0,
          unread_count: 0
        })
      );
    else {
      n((u) => u.setMetadata({ ...r, unread_count: 0 }));
      const o = { read_at: (/* @__PURE__ */ new Date()).toISOString() }, a = s.map((u) => u.id);
      n((u) => u.setItemAttrs(a, o));
    }
    const i = await this.makeBulkStatusUpdate("read");
    return this.broadcaster.emit("items:all_read", { items: s }), this.broadcastOverChannel("items:all_read", { items: s }), i;
  }
  async markAsUnread(t) {
    return this.optimisticallyPerformStatusUpdate(
      t,
      "unread",
      { read_at: null },
      "unread_count"
    ), this.makeStatusUpdate(t, "unread");
  }
  async markAsInteracted(t) {
    const n = (/* @__PURE__ */ new Date()).toISOString();
    return this.optimisticallyPerformStatusUpdate(
      t,
      "interacted",
      {
        read_at: n,
        interacted_at: n
      },
      "unread_count"
    ), this.makeStatusUpdate(t, "interacted");
  }
  /*
    Marking one or more items as archived should:
  
    - Decrement the badge count for any unread / unseen items
    - Remove the item from the feed list when the `archived` flag is "exclude" (default)
  
    TODO: how do we handle rollbacks?
    */
  async markAsArchived(t) {
    const { getState: n, setState: r } = this.store, s = n(), i = this.defaultOptions.archived === "exclude", o = Array.isArray(t) ? t : [t], a = o.map((u) => u.id);
    if (i) {
      const u = o.filter((w) => !w.seen_at).length, l = o.filter((w) => !w.read_at).length, d = {
        ...s.metadata,
        total_count: s.metadata.total_count - o.length,
        unseen_count: s.metadata.unseen_count - u,
        unread_count: s.metadata.unread_count - l
      }, h = s.items.filter(
        (w) => !a.includes(w.id)
      );
      r(
        (w) => w.setResult({
          entries: h,
          meta: d,
          page_info: w.pageInfo
        })
      );
    } else
      s.setItemAttrs(a, { archived_at: (/* @__PURE__ */ new Date()).toISOString() });
    return this.makeStatusUpdate(t, "archived");
  }
  async markAllAsArchived() {
    const { setState: t, getState: n } = this.store, { items: r } = n(), s = this.defaultOptions.archived === "exclude";
    t(s ? (o) => o.resetStore() : (o) => {
      const a = r.map((u) => u.id);
      o.setItemAttrs(a, { archived_at: (/* @__PURE__ */ new Date()).toISOString() });
    });
    const i = await this.makeBulkStatusUpdate("archive");
    return this.broadcaster.emit("items:all_archived", { items: r }), this.broadcastOverChannel("items:all_archived", { items: r }), i;
  }
  async markAsUnarchived(t) {
    return this.optimisticallyPerformStatusUpdate(t, "unarchived", {
      archived_at: null
    }), this.makeStatusUpdate(t, "unarchived");
  }
  /* Fetches the feed content, appending it to the store */
  async fetch(t = {}) {
    const { setState: n, getState: r } = this.store, { networkStatus: s } = r();
    if (ei(s))
      return;
    n(
      (d) => d.setNetworkStatus(t.__loadingType ?? Ce.loading)
    );
    const i = {
      ...this.defaultOptions,
      ...t,
      // Unset options that should not be sent to the API
      __loadingType: void 0,
      __fetchSource: void 0,
      __experimentalCrossBrowserUpdates: void 0,
      auto_manage_socket_connection: void 0,
      auto_manage_socket_connection_delay: void 0
    }, o = await this.knock.client().makeRequest({
      method: "GET",
      url: `/v1/users/${this.knock.userId}/feeds/${this.feedId}`,
      params: i
    });
    if (o.statusCode === "error" || !o.body)
      return n((d) => d.setNetworkStatus(Ce.error)), {
        status: o.statusCode,
        data: o.error || o.body
      };
    const a = {
      entries: o.body.entries,
      meta: o.body.meta,
      page_info: o.body.page_info
    };
    if (t.before) {
      const d = { shouldSetPage: !1, shouldAppend: !0 };
      n((h) => h.setResult(a, d));
    } else if (t.after) {
      const d = { shouldSetPage: !0, shouldAppend: !0 };
      n((h) => h.setResult(a, d));
    } else
      n((d) => d.setResult(a));
    this.broadcast("messages.new", a);
    const u = t.__fetchSource === "socket" ? "items.received.realtime" : "items.received.page", l = {
      items: a.entries,
      metadata: a.meta,
      event: u
    };
    return this.broadcast(l.event, l), { data: a, status: o.statusCode };
  }
  async fetchNextPage() {
    const { getState: t } = this.store, { pageInfo: n } = t();
    n.after && this.fetch({
      after: n.after,
      __loadingType: Ce.fetchMore
    });
  }
  broadcast(t, n) {
    this.broadcaster.emit(t, n);
  }
  // Invoked when a new real-time message comes in from the socket
  async onNewMessageReceived({
    metadata: t
  }) {
    this.knock.log("[Feed] Received new real-time message");
    const { getState: n, setState: r } = this.store, { items: s } = n(), i = s[0];
    r((o) => o.setMetadata(t)), this.fetch({ before: i == null ? void 0 : i.__cursor, __fetchSource: "socket" });
  }
  buildUserFeedId() {
    return `${this.feedId}:${this.knock.userId}`;
  }
  optimisticallyPerformStatusUpdate(t, n, r, s) {
    const { getState: i, setState: o } = this.store, a = Array.isArray(t) ? t : [t], u = a.map((l) => l.id);
    if (s) {
      const { metadata: l } = i(), d = a.filter((w) => {
        switch (n) {
          case "seen":
            return w.seen_at === null;
          case "unseen":
            return w.seen_at !== null;
          case "read":
          case "interacted":
            return w.read_at === null;
          case "unread":
            return w.read_at !== null;
          default:
            return !0;
        }
      }), h = n.startsWith("un") ? d.length : -d.length;
      o(
        (w) => w.setMetadata({
          ...l,
          [s]: Math.max(0, l[s] + h)
        })
      );
    }
    o((l) => l.setItemAttrs(u, r));
  }
  async makeStatusUpdate(t, n) {
    const r = Array.isArray(t) ? t : [t], s = r.map((o) => o.id), i = await this.knock.client().makeRequest({
      method: "POST",
      url: `/v1/messages/batch/${n}`,
      data: { message_ids: s }
    });
    return this.broadcaster.emit(`items:${n}`, { items: r }), this.broadcastOverChannel(`items:${n}`, { items: r }), i;
  }
  async makeBulkStatusUpdate(t) {
    const n = {
      user_ids: [this.knock.userId],
      engagement_status: this.defaultOptions.status !== "all" ? this.defaultOptions.status : void 0,
      archived: this.defaultOptions.archived,
      has_tenant: this.defaultOptions.has_tenant,
      tenants: this.defaultOptions.tenant ? [this.defaultOptions.tenant] : void 0
    };
    return await this.knock.client().makeRequest({
      method: "POST",
      url: `/v1/channels/${this.feedId}/messages/bulk/${t}`,
      data: n
    });
  }
  setupBroadcastChannel() {
    this.broadcastChannel = typeof self < "u" && "BroadcastChannel" in self ? new BroadcastChannel(`knock:feed:${this.userFeedId}`) : null, this.broadcastChannel && this.defaultOptions.__experimentalCrossBrowserUpdates === !0 && (this.broadcastChannel.onmessage = (t) => {
      switch (t.data.type) {
        case "items:archived":
        case "items:unarchived":
        case "items:seen":
        case "items:unseen":
        case "items:read":
        case "items:unread":
        case "items:all_read":
        case "items:all_seen":
        case "items:all_archived":
          return this.fetch();
        default:
          return null;
      }
    });
  }
  broadcastOverChannel(t, n) {
    if (this.broadcastChannel)
      try {
        const r = JSON.parse(JSON.stringify(n));
        this.broadcastChannel.postMessage({
          type: t,
          payload: r
        });
      } catch (r) {
        console.warn(`Could not broadcast ${t}, got error: ${r}`);
      }
  }
  initializeRealtimeConnection() {
    const { socket: t } = this.knock.client();
    t && (this.channel = t.channel(
      `feeds:${this.userFeedId}`,
      this.defaultOptions
    ), this.channel.on("new-message", (n) => this.onNewMessageReceived(n)), this.defaultOptions.auto_manage_socket_connection && this.setupAutoSocketManager(
      this.defaultOptions.auto_manage_socket_connection_delay
    ), this.hasSubscribedToRealTimeUpdates && (t.isConnected() || t.connect(), this.channel.join()));
  }
  /**
   * Listen for changes to document visibility and automatically disconnect
   * or reconnect the socket after a delay
   */
  setupAutoSocketManager(t) {
    const n = t ?? li;
    document.addEventListener("visibilitychange", () => {
      var r;
      const s = this.knock.client();
      document.visibilityState === "hidden" ? this.disconnectTimer = setTimeout(() => {
        var i;
        (i = s.socket) == null || i.disconnect(), this.disconnectTimer = null;
      }, n) : document.visibilityState === "visible" && (this.disconnectTimer && (clearTimeout(this.disconnectTimer), this.disconnectTimer = null), (r = s.socket) != null && r.isConnected() || this.initializeRealtimeConnection());
    });
  }
}
var di = Object.defineProperty, hi = (e, t, n) => t in e ? di(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, In = (e, t, n) => (hi(e, typeof t != "symbol" ? t + "" : t, n), n);
let mi = class {
  constructor(t) {
    In(this, "instance"), In(this, "feedInstances", []), this.instance = t;
  }
  initialize(t, n = {}) {
    const r = new fi(this.instance, t, n);
    return this.feedInstances.push(r), r;
  }
  removeInstance(t) {
    this.feedInstances = this.feedInstances.filter((n) => n !== t);
  }
  teardownInstances() {
    for (const t of this.feedInstances)
      t.teardown();
  }
  reinitializeInstances() {
    for (const t of this.feedInstances)
      t.reinitialize();
  }
};
class tt extends Error {
}
tt.prototype.name = "InvalidTokenError";
function pi(e) {
  return decodeURIComponent(atob(e).replace(/(.)/g, (t, n) => {
    let r = n.charCodeAt(0).toString(16).toUpperCase();
    return r.length < 2 && (r = "0" + r), "%" + r;
  }));
}
function gi(e) {
  let t = e.replace(/-/g, "+").replace(/_/g, "/");
  switch (t.length % 4) {
    case 0:
      break;
    case 2:
      t += "==";
      break;
    case 3:
      t += "=";
      break;
    default:
      throw new Error("base64 string is not of the correct length");
  }
  try {
    return pi(t);
  } catch {
    return atob(t);
  }
}
function yi(e, t) {
  if (typeof e != "string")
    throw new tt("Invalid token specified: must be a string");
  t || (t = {});
  const n = t.header === !0 ? 0 : 1, r = e.split(".")[n];
  if (typeof r != "string")
    throw new tt(`Invalid token specified: missing part #${n + 1}`);
  let s;
  try {
    s = gi(r);
  } catch (i) {
    throw new tt(`Invalid token specified: invalid base64 for part #${n + 1} (${i.message})`);
  }
  try {
    return JSON.parse(s);
  } catch (i) {
    throw new tt(`Invalid token specified: invalid json for part #${n + 1} (${i.message})`);
  }
}
function Nr(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: wi } = Object.prototype, { getPrototypeOf: vn } = Object, Pt = /* @__PURE__ */ ((e) => (t) => {
  const n = wi.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), ie = (e) => (e = e.toLowerCase(), (t) => Pt(t) === e), xt = (e) => (t) => typeof t === e, { isArray: ze } = Array, ot = xt("undefined");
function _i(e) {
  return e !== null && !ot(e) && e.constructor !== null && !ot(e.constructor) && ne(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Lr = ie("ArrayBuffer");
function vi(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && Lr(e.buffer), t;
}
const bi = xt("string"), ne = xt("function"), Dr = xt("number"), Nt = (e) => e !== null && typeof e == "object", Ti = (e) => e === !0 || e === !1, vt = (e) => {
  if (Pt(e) !== "object")
    return !1;
  const t = vn(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, Ei = ie("Date"), Si = ie("File"), Oi = ie("Blob"), Ci = ie("FileList"), Ri = (e) => Nt(e) && ne(e.pipe), ki = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || ne(e.append) && ((t = Pt(e)) === "formdata" || // detect form-data instance
  t === "object" && ne(e.toString) && e.toString() === "[object FormData]"));
}, Ai = ie("URLSearchParams"), [Pi, xi, Ni, Li] = ["ReadableStream", "Request", "Response", "Headers"].map(ie), Di = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function lt(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let r, s;
  if (typeof e != "object" && (e = [e]), ze(e))
    for (r = 0, s = e.length; r < s; r++)
      t.call(null, e[r], r, e);
  else {
    const i = n ? Object.getOwnPropertyNames(e) : Object.keys(e), o = i.length;
    let a;
    for (r = 0; r < o; r++)
      a = i[r], t.call(null, e[a], a, e);
  }
}
function Ir(e, t) {
  t = t.toLowerCase();
  const n = Object.keys(e);
  let r = n.length, s;
  for (; r-- > 0; )
    if (s = n[r], t === s.toLowerCase())
      return s;
  return null;
}
const De = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Mr = (e) => !ot(e) && e !== De;
function sn() {
  const { caseless: e } = Mr(this) && this || {}, t = {}, n = (r, s) => {
    const i = e && Ir(t, s) || s;
    vt(t[i]) && vt(r) ? t[i] = sn(t[i], r) : vt(r) ? t[i] = sn({}, r) : ze(r) ? t[i] = r.slice() : t[i] = r;
  };
  for (let r = 0, s = arguments.length; r < s; r++)
    arguments[r] && lt(arguments[r], n);
  return t;
}
const Ii = (e, t, n, { allOwnKeys: r } = {}) => (lt(t, (s, i) => {
  n && ne(s) ? e[i] = Nr(s, n) : e[i] = s;
}, { allOwnKeys: r }), e), Mi = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), ji = (e, t, n, r) => {
  e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, $i = (e, t, n, r) => {
  let s, i, o;
  const a = {};
  if (t = t || {}, e == null) return t;
  do {
    for (s = Object.getOwnPropertyNames(e), i = s.length; i-- > 0; )
      o = s[i], (!r || r(o, e, t)) && !a[o] && (t[o] = e[o], a[o] = !0);
    e = n !== !1 && vn(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, Ui = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const r = e.indexOf(t, n);
  return r !== -1 && r === n;
}, Fi = (e) => {
  if (!e) return null;
  if (ze(e)) return e;
  let t = e.length;
  if (!Dr(t)) return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, Bi = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && vn(Uint8Array)), Hi = (e, t) => {
  const r = (e && e[Symbol.iterator]).call(e);
  let s;
  for (; (s = r.next()) && !s.done; ) {
    const i = s.value;
    t.call(e, i[0], i[1]);
  }
}, qi = (e, t) => {
  let n;
  const r = [];
  for (; (n = e.exec(t)) !== null; )
    r.push(n);
  return r;
}, Wi = ie("HTMLFormElement"), zi = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, r, s) {
    return r.toUpperCase() + s;
  }
), Mn = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), Yi = ie("RegExp"), jr = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), r = {};
  lt(n, (s, i) => {
    let o;
    (o = t(s, i, e)) !== !1 && (r[i] = o || s);
  }), Object.defineProperties(e, r);
}, Vi = (e) => {
  jr(e, (t, n) => {
    if (ne(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = e[n];
    if (ne(r)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, Gi = (e, t) => {
  const n = {}, r = (s) => {
    s.forEach((i) => {
      n[i] = !0;
    });
  };
  return ze(e) ? r(e) : r(String(e).split(t)), n;
}, Ki = () => {
}, Ji = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function Xi(e) {
  return !!(e && ne(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const Zi = (e) => {
  const t = new Array(10), n = (r, s) => {
    if (Nt(r)) {
      if (t.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        t[s] = r;
        const i = ze(r) ? [] : {};
        return lt(r, (o, a) => {
          const u = n(o, s + 1);
          !ot(u) && (i[a] = u);
        }), t[s] = void 0, i;
      }
    }
    return r;
  };
  return n(e, 0);
}, Qi = ie("AsyncFunction"), eo = (e) => e && (Nt(e) || ne(e)) && ne(e.then) && ne(e.catch), $r = ((e, t) => e ? setImmediate : t ? ((n, r) => (De.addEventListener("message", ({ source: s, data: i }) => {
  s === De && i === n && r.length && r.shift()();
}, !1), (s) => {
  r.push(s), De.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(
  typeof setImmediate == "function",
  ne(De.postMessage)
), to = typeof queueMicrotask < "u" ? queueMicrotask.bind(De) : typeof process < "u" && process.nextTick || $r, g = {
  isArray: ze,
  isArrayBuffer: Lr,
  isBuffer: _i,
  isFormData: ki,
  isArrayBufferView: vi,
  isString: bi,
  isNumber: Dr,
  isBoolean: Ti,
  isObject: Nt,
  isPlainObject: vt,
  isReadableStream: Pi,
  isRequest: xi,
  isResponse: Ni,
  isHeaders: Li,
  isUndefined: ot,
  isDate: Ei,
  isFile: Si,
  isBlob: Oi,
  isRegExp: Yi,
  isFunction: ne,
  isStream: Ri,
  isURLSearchParams: Ai,
  isTypedArray: Bi,
  isFileList: Ci,
  forEach: lt,
  merge: sn,
  extend: Ii,
  trim: Di,
  stripBOM: Mi,
  inherits: ji,
  toFlatObject: $i,
  kindOf: Pt,
  kindOfTest: ie,
  endsWith: Ui,
  toArray: Fi,
  forEachEntry: Hi,
  matchAll: qi,
  isHTMLForm: Wi,
  hasOwnProperty: Mn,
  hasOwnProp: Mn,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: jr,
  freezeMethods: Vi,
  toObjectSet: Gi,
  toCamelCase: zi,
  noop: Ki,
  toFiniteNumber: Ji,
  findKey: Ir,
  global: De,
  isContextDefined: Mr,
  isSpecCompliantForm: Xi,
  toJSONObject: Zi,
  isAsyncFn: Qi,
  isThenable: eo,
  setImmediate: $r,
  asap: to
};
function N(e, t, n, r, s) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), s && (this.response = s, this.status = s.status ? s.status : null);
}
g.inherits(N, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: g.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const Ur = N.prototype, Fr = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  Fr[e] = { value: e };
});
Object.defineProperties(N, Fr);
Object.defineProperty(Ur, "isAxiosError", { value: !0 });
N.from = (e, t, n, r, s, i) => {
  const o = Object.create(Ur);
  return g.toFlatObject(e, o, function(u) {
    return u !== Error.prototype;
  }, (a) => a !== "isAxiosError"), N.call(o, e.message, t, n, r, s), o.cause = e, o.name = e.name, i && Object.assign(o, i), o;
};
const no = null;
function on(e) {
  return g.isPlainObject(e) || g.isArray(e);
}
function Br(e) {
  return g.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function jn(e, t, n) {
  return e ? e.concat(t).map(function(s, i) {
    return s = Br(s), !n && i ? "[" + s + "]" : s;
  }).join(n ? "." : "") : t;
}
function ro(e) {
  return g.isArray(e) && !e.some(on);
}
const so = g.toFlatObject(g, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function Lt(e, t, n) {
  if (!g.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = g.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(b, O) {
    return !g.isUndefined(O[b]);
  });
  const r = n.metaTokens, s = n.visitor || d, i = n.dots, o = n.indexes, u = (n.Blob || typeof Blob < "u" && Blob) && g.isSpecCompliantForm(t);
  if (!g.isFunction(s))
    throw new TypeError("visitor must be a function");
  function l(_) {
    if (_ === null) return "";
    if (g.isDate(_))
      return _.toISOString();
    if (!u && g.isBlob(_))
      throw new N("Blob is not supported. Use a Buffer instead.");
    return g.isArrayBuffer(_) || g.isTypedArray(_) ? u && typeof Blob == "function" ? new Blob([_]) : Buffer.from(_) : _;
  }
  function d(_, b, O) {
    let P = _;
    if (_ && !O && typeof _ == "object") {
      if (g.endsWith(b, "{}"))
        b = r ? b : b.slice(0, -2), _ = JSON.stringify(_);
      else if (g.isArray(_) && ro(_) || (g.isFileList(_) || g.endsWith(b, "[]")) && (P = g.toArray(_)))
        return b = Br(b), P.forEach(function(x, W) {
          !(g.isUndefined(x) || x === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            o === !0 ? jn([b], W, i) : o === null ? b : b + "[]",
            l(x)
          );
        }), !1;
    }
    return on(_) ? !0 : (t.append(jn(O, b, i), l(_)), !1);
  }
  const h = [], w = Object.assign(so, {
    defaultVisitor: d,
    convertValue: l,
    isVisitable: on
  });
  function R(_, b) {
    if (!g.isUndefined(_)) {
      if (h.indexOf(_) !== -1)
        throw Error("Circular reference detected in " + b.join("."));
      h.push(_), g.forEach(_, function(P, A) {
        (!(g.isUndefined(P) || P === null) && s.call(
          t,
          P,
          g.isString(A) ? A.trim() : A,
          b,
          w
        )) === !0 && R(P, b ? b.concat(A) : [A]);
      }), h.pop();
    }
  }
  if (!g.isObject(e))
    throw new TypeError("data must be an object");
  return R(e), t;
}
function $n(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
    return t[r];
  });
}
function bn(e, t) {
  this._pairs = [], e && Lt(e, this, t);
}
const Hr = bn.prototype;
Hr.append = function(t, n) {
  this._pairs.push([t, n]);
};
Hr.toString = function(t) {
  const n = t ? function(r) {
    return t.call(this, r, $n);
  } : $n;
  return this._pairs.map(function(s) {
    return n(s[0]) + "=" + n(s[1]);
  }, "").join("&");
};
function io(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function qr(e, t, n) {
  if (!t)
    return e;
  const r = n && n.encode || io;
  g.isFunction(n) && (n = {
    serialize: n
  });
  const s = n && n.serialize;
  let i;
  if (s ? i = s(t, n) : i = g.isURLSearchParams(t) ? t.toString() : new bn(t, n).toString(r), i) {
    const o = e.indexOf("#");
    o !== -1 && (e = e.slice(0, o)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
class Un {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, r) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    g.forEach(this.handlers, function(r) {
      r !== null && t(r);
    });
  }
}
const Wr = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, oo = typeof URLSearchParams < "u" ? URLSearchParams : bn, ao = typeof FormData < "u" ? FormData : null, co = typeof Blob < "u" ? Blob : null, uo = {
  isBrowser: !0,
  classes: {
    URLSearchParams: oo,
    FormData: ao,
    Blob: co
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Tn = typeof window < "u" && typeof document < "u", an = typeof navigator == "object" && navigator || void 0, lo = Tn && (!an || ["ReactNative", "NativeScript", "NS"].indexOf(an.product) < 0), fo = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", ho = Tn && window.location.href || "http://localhost", mo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Tn,
  hasStandardBrowserEnv: lo,
  hasStandardBrowserWebWorkerEnv: fo,
  navigator: an,
  origin: ho
}, Symbol.toStringTag, { value: "Module" })), G = {
  ...mo,
  ...uo
};
function po(e, t) {
  return Lt(e, new G.classes.URLSearchParams(), Object.assign({
    visitor: function(n, r, s, i) {
      return G.isNode && g.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function go(e) {
  return g.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function yo(e) {
  const t = {}, n = Object.keys(e);
  let r;
  const s = n.length;
  let i;
  for (r = 0; r < s; r++)
    i = n[r], t[i] = e[i];
  return t;
}
function zr(e) {
  function t(n, r, s, i) {
    let o = n[i++];
    if (o === "__proto__") return !0;
    const a = Number.isFinite(+o), u = i >= n.length;
    return o = !o && g.isArray(s) ? s.length : o, u ? (g.hasOwnProp(s, o) ? s[o] = [s[o], r] : s[o] = r, !a) : ((!s[o] || !g.isObject(s[o])) && (s[o] = []), t(n, r, s[o], i) && g.isArray(s[o]) && (s[o] = yo(s[o])), !a);
  }
  if (g.isFormData(e) && g.isFunction(e.entries)) {
    const n = {};
    return g.forEachEntry(e, (r, s) => {
      t(go(r), s, n, 0);
    }), n;
  }
  return null;
}
function wo(e, t, n) {
  if (g.isString(e))
    try {
      return (t || JSON.parse)(e), g.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (n || JSON.stringify)(e);
}
const ft = {
  transitional: Wr,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, n) {
    const r = n.getContentType() || "", s = r.indexOf("application/json") > -1, i = g.isObject(t);
    if (i && g.isHTMLForm(t) && (t = new FormData(t)), g.isFormData(t))
      return s ? JSON.stringify(zr(t)) : t;
    if (g.isArrayBuffer(t) || g.isBuffer(t) || g.isStream(t) || g.isFile(t) || g.isBlob(t) || g.isReadableStream(t))
      return t;
    if (g.isArrayBufferView(t))
      return t.buffer;
    if (g.isURLSearchParams(t))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let a;
    if (i) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return po(t, this.formSerializer).toString();
      if ((a = g.isFileList(t)) || r.indexOf("multipart/form-data") > -1) {
        const u = this.env && this.env.FormData;
        return Lt(
          a ? { "files[]": t } : t,
          u && new u(),
          this.formSerializer
        );
      }
    }
    return i || s ? (n.setContentType("application/json", !1), wo(t)) : t;
  }],
  transformResponse: [function(t) {
    const n = this.transitional || ft.transitional, r = n && n.forcedJSONParsing, s = this.responseType === "json";
    if (g.isResponse(t) || g.isReadableStream(t))
      return t;
    if (t && g.isString(t) && (r && !this.responseType || s)) {
      const o = !(n && n.silentJSONParsing) && s;
      try {
        return JSON.parse(t);
      } catch (a) {
        if (o)
          throw a.name === "SyntaxError" ? N.from(a, N.ERR_BAD_RESPONSE, this, null, this.response) : a;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: G.classes.FormData,
    Blob: G.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
g.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  ft.headers[e] = {};
});
const _o = g.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), vo = (e) => {
  const t = {};
  let n, r, s;
  return e && e.split(`
`).forEach(function(o) {
    s = o.indexOf(":"), n = o.substring(0, s).trim().toLowerCase(), r = o.substring(s + 1).trim(), !(!n || t[n] && _o[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [r] : t[n] = t[n] ? t[n] + ", " + r : r);
  }), t;
}, Fn = Symbol("internals");
function Ke(e) {
  return e && String(e).trim().toLowerCase();
}
function bt(e) {
  return e === !1 || e == null ? e : g.isArray(e) ? e.map(bt) : String(e);
}
function bo(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(e); )
    t[r[1]] = r[2];
  return t;
}
const To = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Yt(e, t, n, r, s) {
  if (g.isFunction(r))
    return r.call(this, t, n);
  if (s && (t = n), !!g.isString(t)) {
    if (g.isString(r))
      return t.indexOf(r) !== -1;
    if (g.isRegExp(r))
      return r.test(t);
  }
}
function Eo(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, r) => n.toUpperCase() + r);
}
function So(e, t) {
  const n = g.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(e, r + n, {
      value: function(s, i, o) {
        return this[r].call(this, t, s, i, o);
      },
      configurable: !0
    });
  });
}
let Q = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, r) {
    const s = this;
    function i(a, u, l) {
      const d = Ke(u);
      if (!d)
        throw new Error("header name must be a non-empty string");
      const h = g.findKey(s, d);
      (!h || s[h] === void 0 || l === !0 || l === void 0 && s[h] !== !1) && (s[h || u] = bt(a));
    }
    const o = (a, u) => g.forEach(a, (l, d) => i(l, d, u));
    if (g.isPlainObject(t) || t instanceof this.constructor)
      o(t, n);
    else if (g.isString(t) && (t = t.trim()) && !To(t))
      o(vo(t), n);
    else if (g.isHeaders(t))
      for (const [a, u] of t.entries())
        i(u, a, r);
    else
      t != null && i(n, t, r);
    return this;
  }
  get(t, n) {
    if (t = Ke(t), t) {
      const r = g.findKey(this, t);
      if (r) {
        const s = this[r];
        if (!n)
          return s;
        if (n === !0)
          return bo(s);
        if (g.isFunction(n))
          return n.call(this, s, r);
        if (g.isRegExp(n))
          return n.exec(s);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = Ke(t), t) {
      const r = g.findKey(this, t);
      return !!(r && this[r] !== void 0 && (!n || Yt(this, this[r], r, n)));
    }
    return !1;
  }
  delete(t, n) {
    const r = this;
    let s = !1;
    function i(o) {
      if (o = Ke(o), o) {
        const a = g.findKey(r, o);
        a && (!n || Yt(r, r[a], a, n)) && (delete r[a], s = !0);
      }
    }
    return g.isArray(t) ? t.forEach(i) : i(t), s;
  }
  clear(t) {
    const n = Object.keys(this);
    let r = n.length, s = !1;
    for (; r--; ) {
      const i = n[r];
      (!t || Yt(this, this[i], i, t, !0)) && (delete this[i], s = !0);
    }
    return s;
  }
  normalize(t) {
    const n = this, r = {};
    return g.forEach(this, (s, i) => {
      const o = g.findKey(r, i);
      if (o) {
        n[o] = bt(s), delete n[i];
        return;
      }
      const a = t ? Eo(i) : String(i).trim();
      a !== i && delete n[i], n[a] = bt(s), r[a] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return g.forEach(this, (r, s) => {
      r != null && r !== !1 && (n[s] = t && g.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const r = new this(t);
    return n.forEach((s) => r.set(s)), r;
  }
  static accessor(t) {
    const r = (this[Fn] = this[Fn] = {
      accessors: {}
    }).accessors, s = this.prototype;
    function i(o) {
      const a = Ke(o);
      r[a] || (So(s, o), r[a] = !0);
    }
    return g.isArray(t) ? t.forEach(i) : i(t), this;
  }
};
Q.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
g.reduceDescriptors(Q.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(r) {
      this[n] = r;
    }
  };
});
g.freezeMethods(Q);
function Vt(e, t) {
  const n = this || ft, r = t || n, s = Q.from(r.headers);
  let i = r.data;
  return g.forEach(e, function(a) {
    i = a.call(n, i, s.normalize(), t ? t.status : void 0);
  }), s.normalize(), i;
}
function Yr(e) {
  return !!(e && e.__CANCEL__);
}
function Ye(e, t, n) {
  N.call(this, e ?? "canceled", N.ERR_CANCELED, t, n), this.name = "CanceledError";
}
g.inherits(Ye, N, {
  __CANCEL__: !0
});
function Vr(e, t, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? e(n) : t(new N(
    "Request failed with status code " + n.status,
    [N.ERR_BAD_REQUEST, N.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function Oo(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function Co(e, t) {
  e = e || 10;
  const n = new Array(e), r = new Array(e);
  let s = 0, i = 0, o;
  return t = t !== void 0 ? t : 1e3, function(u) {
    const l = Date.now(), d = r[i];
    o || (o = l), n[s] = u, r[s] = l;
    let h = i, w = 0;
    for (; h !== s; )
      w += n[h++], h = h % e;
    if (s = (s + 1) % e, s === i && (i = (i + 1) % e), l - o < t)
      return;
    const R = d && l - d;
    return R ? Math.round(w * 1e3 / R) : void 0;
  };
}
function Ro(e, t) {
  let n = 0, r = 1e3 / t, s, i;
  const o = (l, d = Date.now()) => {
    n = d, s = null, i && (clearTimeout(i), i = null), e.apply(null, l);
  };
  return [(...l) => {
    const d = Date.now(), h = d - n;
    h >= r ? o(l, d) : (s = l, i || (i = setTimeout(() => {
      i = null, o(s);
    }, r - h)));
  }, () => s && o(s)];
}
const St = (e, t, n = 3) => {
  let r = 0;
  const s = Co(50, 250);
  return Ro((i) => {
    const o = i.loaded, a = i.lengthComputable ? i.total : void 0, u = o - r, l = s(u), d = o <= a;
    r = o;
    const h = {
      loaded: o,
      total: a,
      progress: a ? o / a : void 0,
      bytes: u,
      rate: l || void 0,
      estimated: l && a && d ? (a - o) / l : void 0,
      event: i,
      lengthComputable: a != null,
      [t ? "download" : "upload"]: !0
    };
    e(h);
  }, n);
}, Bn = (e, t) => {
  const n = e != null;
  return [(r) => t[0]({
    lengthComputable: n,
    total: e,
    loaded: r
  }), t[1]];
}, Hn = (e) => (...t) => g.asap(() => e(...t)), ko = G.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (n) => (n = new URL(n, G.origin), e.protocol === n.protocol && e.host === n.host && (t || e.port === n.port)))(
  new URL(G.origin),
  G.navigator && /(msie|trident)/i.test(G.navigator.userAgent)
) : () => !0, Ao = G.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, r, s, i) {
      const o = [e + "=" + encodeURIComponent(t)];
      g.isNumber(n) && o.push("expires=" + new Date(n).toGMTString()), g.isString(r) && o.push("path=" + r), g.isString(s) && o.push("domain=" + s), i === !0 && o.push("secure"), document.cookie = o.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function Po(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function xo(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function Gr(e, t, n) {
  let r = !Po(t);
  return e && (r || n == !1) ? xo(e, t) : t;
}
const qn = (e) => e instanceof Q ? { ...e } : e;
function Me(e, t) {
  t = t || {};
  const n = {};
  function r(l, d, h, w) {
    return g.isPlainObject(l) && g.isPlainObject(d) ? g.merge.call({ caseless: w }, l, d) : g.isPlainObject(d) ? g.merge({}, d) : g.isArray(d) ? d.slice() : d;
  }
  function s(l, d, h, w) {
    if (g.isUndefined(d)) {
      if (!g.isUndefined(l))
        return r(void 0, l, h, w);
    } else return r(l, d, h, w);
  }
  function i(l, d) {
    if (!g.isUndefined(d))
      return r(void 0, d);
  }
  function o(l, d) {
    if (g.isUndefined(d)) {
      if (!g.isUndefined(l))
        return r(void 0, l);
    } else return r(void 0, d);
  }
  function a(l, d, h) {
    if (h in t)
      return r(l, d);
    if (h in e)
      return r(void 0, l);
  }
  const u = {
    url: i,
    method: i,
    data: i,
    baseURL: o,
    transformRequest: o,
    transformResponse: o,
    paramsSerializer: o,
    timeout: o,
    timeoutMessage: o,
    withCredentials: o,
    withXSRFToken: o,
    adapter: o,
    responseType: o,
    xsrfCookieName: o,
    xsrfHeaderName: o,
    onUploadProgress: o,
    onDownloadProgress: o,
    decompress: o,
    maxContentLength: o,
    maxBodyLength: o,
    beforeRedirect: o,
    transport: o,
    httpAgent: o,
    httpsAgent: o,
    cancelToken: o,
    socketPath: o,
    responseEncoding: o,
    validateStatus: a,
    headers: (l, d, h) => s(qn(l), qn(d), h, !0)
  };
  return g.forEach(Object.keys(Object.assign({}, e, t)), function(d) {
    const h = u[d] || s, w = h(e[d], t[d], d);
    g.isUndefined(w) && h !== a || (n[d] = w);
  }), n;
}
const Kr = (e) => {
  const t = Me({}, e);
  let { data: n, withXSRFToken: r, xsrfHeaderName: s, xsrfCookieName: i, headers: o, auth: a } = t;
  t.headers = o = Q.from(o), t.url = qr(Gr(t.baseURL, t.url, t.allowAbsoluteUrls), e.params, e.paramsSerializer), a && o.set(
    "Authorization",
    "Basic " + btoa((a.username || "") + ":" + (a.password ? unescape(encodeURIComponent(a.password)) : ""))
  );
  let u;
  if (g.isFormData(n)) {
    if (G.hasStandardBrowserEnv || G.hasStandardBrowserWebWorkerEnv)
      o.setContentType(void 0);
    else if ((u = o.getContentType()) !== !1) {
      const [l, ...d] = u ? u.split(";").map((h) => h.trim()).filter(Boolean) : [];
      o.setContentType([l || "multipart/form-data", ...d].join("; "));
    }
  }
  if (G.hasStandardBrowserEnv && (r && g.isFunction(r) && (r = r(t)), r || r !== !1 && ko(t.url))) {
    const l = s && i && Ao.read(i);
    l && o.set(s, l);
  }
  return t;
}, No = typeof XMLHttpRequest < "u", Lo = No && function(e) {
  return new Promise(function(n, r) {
    const s = Kr(e);
    let i = s.data;
    const o = Q.from(s.headers).normalize();
    let { responseType: a, onUploadProgress: u, onDownloadProgress: l } = s, d, h, w, R, _;
    function b() {
      R && R(), _ && _(), s.cancelToken && s.cancelToken.unsubscribe(d), s.signal && s.signal.removeEventListener("abort", d);
    }
    let O = new XMLHttpRequest();
    O.open(s.method.toUpperCase(), s.url, !0), O.timeout = s.timeout;
    function P() {
      if (!O)
        return;
      const x = Q.from(
        "getAllResponseHeaders" in O && O.getAllResponseHeaders()
      ), F = {
        data: !a || a === "text" || a === "json" ? O.responseText : O.response,
        status: O.status,
        statusText: O.statusText,
        headers: x,
        config: e,
        request: O
      };
      Vr(function(ae) {
        n(ae), b();
      }, function(ae) {
        r(ae), b();
      }, F), O = null;
    }
    "onloadend" in O ? O.onloadend = P : O.onreadystatechange = function() {
      !O || O.readyState !== 4 || O.status === 0 && !(O.responseURL && O.responseURL.indexOf("file:") === 0) || setTimeout(P);
    }, O.onabort = function() {
      O && (r(new N("Request aborted", N.ECONNABORTED, e, O)), O = null);
    }, O.onerror = function() {
      r(new N("Network Error", N.ERR_NETWORK, e, O)), O = null;
    }, O.ontimeout = function() {
      let W = s.timeout ? "timeout of " + s.timeout + "ms exceeded" : "timeout exceeded";
      const F = s.transitional || Wr;
      s.timeoutErrorMessage && (W = s.timeoutErrorMessage), r(new N(
        W,
        F.clarifyTimeoutError ? N.ETIMEDOUT : N.ECONNABORTED,
        e,
        O
      )), O = null;
    }, i === void 0 && o.setContentType(null), "setRequestHeader" in O && g.forEach(o.toJSON(), function(W, F) {
      O.setRequestHeader(F, W);
    }), g.isUndefined(s.withCredentials) || (O.withCredentials = !!s.withCredentials), a && a !== "json" && (O.responseType = s.responseType), l && ([w, _] = St(l, !0), O.addEventListener("progress", w)), u && O.upload && ([h, R] = St(u), O.upload.addEventListener("progress", h), O.upload.addEventListener("loadend", R)), (s.cancelToken || s.signal) && (d = (x) => {
      O && (r(!x || x.type ? new Ye(null, e, O) : x), O.abort(), O = null);
    }, s.cancelToken && s.cancelToken.subscribe(d), s.signal && (s.signal.aborted ? d() : s.signal.addEventListener("abort", d)));
    const A = Oo(s.url);
    if (A && G.protocols.indexOf(A) === -1) {
      r(new N("Unsupported protocol " + A + ":", N.ERR_BAD_REQUEST, e));
      return;
    }
    O.send(i || null);
  });
}, Do = (e, t) => {
  const { length: n } = e = e ? e.filter(Boolean) : [];
  if (t || n) {
    let r = new AbortController(), s;
    const i = function(l) {
      if (!s) {
        s = !0, a();
        const d = l instanceof Error ? l : this.reason;
        r.abort(d instanceof N ? d : new Ye(d instanceof Error ? d.message : d));
      }
    };
    let o = t && setTimeout(() => {
      o = null, i(new N(`timeout ${t} of ms exceeded`, N.ETIMEDOUT));
    }, t);
    const a = () => {
      e && (o && clearTimeout(o), o = null, e.forEach((l) => {
        l.unsubscribe ? l.unsubscribe(i) : l.removeEventListener("abort", i);
      }), e = null);
    };
    e.forEach((l) => l.addEventListener("abort", i));
    const { signal: u } = r;
    return u.unsubscribe = () => g.asap(a), u;
  }
}, Io = function* (e, t) {
  let n = e.byteLength;
  if (n < t) {
    yield e;
    return;
  }
  let r = 0, s;
  for (; r < n; )
    s = r + t, yield e.slice(r, s), r = s;
}, Mo = async function* (e, t) {
  for await (const n of jo(e))
    yield* Io(n, t);
}, jo = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: n, value: r } = await t.read();
      if (n)
        break;
      yield r;
    }
  } finally {
    await t.cancel();
  }
}, Wn = (e, t, n, r) => {
  const s = Mo(e, t);
  let i = 0, o, a = (u) => {
    o || (o = !0, r && r(u));
  };
  return new ReadableStream({
    async pull(u) {
      try {
        const { done: l, value: d } = await s.next();
        if (l) {
          a(), u.close();
          return;
        }
        let h = d.byteLength;
        if (n) {
          let w = i += h;
          n(w);
        }
        u.enqueue(new Uint8Array(d));
      } catch (l) {
        throw a(l), l;
      }
    },
    cancel(u) {
      return a(u), s.return();
    }
  }, {
    highWaterMark: 2
  });
}, Dt = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", Jr = Dt && typeof ReadableStream == "function", $o = Dt && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((e) => (t) => e.encode(t))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), Xr = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, Uo = Jr && Xr(() => {
  let e = !1;
  const t = new Request(G.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
}), zn = 64 * 1024, cn = Jr && Xr(() => g.isReadableStream(new Response("").body)), Ot = {
  stream: cn && ((e) => e.body)
};
Dt && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !Ot[t] && (Ot[t] = g.isFunction(e[t]) ? (n) => n[t]() : (n, r) => {
      throw new N(`Response type '${t}' is not supported`, N.ERR_NOT_SUPPORT, r);
    });
  });
})(new Response());
const Fo = async (e) => {
  if (e == null)
    return 0;
  if (g.isBlob(e))
    return e.size;
  if (g.isSpecCompliantForm(e))
    return (await new Request(G.origin, {
      method: "POST",
      body: e
    }).arrayBuffer()).byteLength;
  if (g.isArrayBufferView(e) || g.isArrayBuffer(e))
    return e.byteLength;
  if (g.isURLSearchParams(e) && (e = e + ""), g.isString(e))
    return (await $o(e)).byteLength;
}, Bo = async (e, t) => {
  const n = g.toFiniteNumber(e.getContentLength());
  return n ?? Fo(t);
}, Ho = Dt && (async (e) => {
  let {
    url: t,
    method: n,
    data: r,
    signal: s,
    cancelToken: i,
    timeout: o,
    onDownloadProgress: a,
    onUploadProgress: u,
    responseType: l,
    headers: d,
    withCredentials: h = "same-origin",
    fetchOptions: w
  } = Kr(e);
  l = l ? (l + "").toLowerCase() : "text";
  let R = Do([s, i && i.toAbortSignal()], o), _;
  const b = R && R.unsubscribe && (() => {
    R.unsubscribe();
  });
  let O;
  try {
    if (u && Uo && n !== "get" && n !== "head" && (O = await Bo(d, r)) !== 0) {
      let F = new Request(t, {
        method: "POST",
        body: r,
        duplex: "half"
      }), oe;
      if (g.isFormData(r) && (oe = F.headers.get("content-type")) && d.setContentType(oe), F.body) {
        const [ae, xe] = Bn(
          O,
          St(Hn(u))
        );
        r = Wn(F.body, zn, ae, xe);
      }
    }
    g.isString(h) || (h = h ? "include" : "omit");
    const P = "credentials" in Request.prototype;
    _ = new Request(t, {
      ...w,
      signal: R,
      method: n.toUpperCase(),
      headers: d.normalize().toJSON(),
      body: r,
      duplex: "half",
      credentials: P ? h : void 0
    });
    let A = await fetch(_);
    const x = cn && (l === "stream" || l === "response");
    if (cn && (a || x && b)) {
      const F = {};
      ["status", "statusText", "headers"].forEach((B) => {
        F[B] = A[B];
      });
      const oe = g.toFiniteNumber(A.headers.get("content-length")), [ae, xe] = a && Bn(
        oe,
        St(Hn(a), !0)
      ) || [];
      A = new Response(
        Wn(A.body, zn, ae, () => {
          xe && xe(), b && b();
        }),
        F
      );
    }
    l = l || "text";
    let W = await Ot[g.findKey(Ot, l) || "text"](A, e);
    return !x && b && b(), await new Promise((F, oe) => {
      Vr(F, oe, {
        data: W,
        headers: Q.from(A.headers),
        status: A.status,
        statusText: A.statusText,
        config: e,
        request: _
      });
    });
  } catch (P) {
    throw b && b(), P && P.name === "TypeError" && /fetch/i.test(P.message) ? Object.assign(
      new N("Network Error", N.ERR_NETWORK, e, _),
      {
        cause: P.cause || P
      }
    ) : N.from(P, P && P.code, e, _);
  }
}), un = {
  http: no,
  xhr: Lo,
  fetch: Ho
};
g.forEach(un, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const Yn = (e) => `- ${e}`, qo = (e) => g.isFunction(e) || e === null || e === !1, Zr = {
  getAdapter: (e) => {
    e = g.isArray(e) ? e : [e];
    const { length: t } = e;
    let n, r;
    const s = {};
    for (let i = 0; i < t; i++) {
      n = e[i];
      let o;
      if (r = n, !qo(n) && (r = un[(o = String(n)).toLowerCase()], r === void 0))
        throw new N(`Unknown adapter '${o}'`);
      if (r)
        break;
      s[o || "#" + i] = r;
    }
    if (!r) {
      const i = Object.entries(s).map(
        ([a, u]) => `adapter ${a} ` + (u === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let o = t ? i.length > 1 ? `since :
` + i.map(Yn).join(`
`) : " " + Yn(i[0]) : "as no adapter specified";
      throw new N(
        "There is no suitable adapter to dispatch the request " + o,
        "ERR_NOT_SUPPORT"
      );
    }
    return r;
  },
  adapters: un
};
function Gt(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Ye(null, e);
}
function Vn(e) {
  return Gt(e), e.headers = Q.from(e.headers), e.data = Vt.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Zr.getAdapter(e.adapter || ft.adapter)(e).then(function(r) {
    return Gt(e), r.data = Vt.call(
      e,
      e.transformResponse,
      r
    ), r.headers = Q.from(r.headers), r;
  }, function(r) {
    return Yr(r) || (Gt(e), r && r.response && (r.response.data = Vt.call(
      e,
      e.transformResponse,
      r.response
    ), r.response.headers = Q.from(r.response.headers))), Promise.reject(r);
  });
}
const Qr = "1.8.4", It = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  It[e] = function(r) {
    return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const Gn = {};
It.transitional = function(t, n, r) {
  function s(i, o) {
    return "[Axios v" + Qr + "] Transitional option '" + i + "'" + o + (r ? ". " + r : "");
  }
  return (i, o, a) => {
    if (t === !1)
      throw new N(
        s(o, " has been removed" + (n ? " in " + n : "")),
        N.ERR_DEPRECATED
      );
    return n && !Gn[o] && (Gn[o] = !0, console.warn(
      s(
        o,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(i, o, a) : !0;
  };
};
It.spelling = function(t) {
  return (n, r) => (console.warn(`${r} is likely a misspelling of ${t}`), !0);
};
function Wo(e, t, n) {
  if (typeof e != "object")
    throw new N("options must be an object", N.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let s = r.length;
  for (; s-- > 0; ) {
    const i = r[s], o = t[i];
    if (o) {
      const a = e[i], u = a === void 0 || o(a, i, e);
      if (u !== !0)
        throw new N("option " + i + " must be " + u, N.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new N("Unknown option " + i, N.ERR_BAD_OPTION);
  }
}
const Tt = {
  assertOptions: Wo,
  validators: It
}, ce = Tt.validators;
let Ie = class {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new Un(),
      response: new Un()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, n) {
    try {
      return await this._request(t, n);
    } catch (r) {
      if (r instanceof Error) {
        let s = {};
        Error.captureStackTrace ? Error.captureStackTrace(s) : s = new Error();
        const i = s.stack ? s.stack.replace(/^.+\n/, "") : "";
        try {
          r.stack ? i && !String(r.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + i) : r.stack = i;
        } catch {
        }
      }
      throw r;
    }
  }
  _request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = Me(this.defaults, n);
    const { transitional: r, paramsSerializer: s, headers: i } = n;
    r !== void 0 && Tt.assertOptions(r, {
      silentJSONParsing: ce.transitional(ce.boolean),
      forcedJSONParsing: ce.transitional(ce.boolean),
      clarifyTimeoutError: ce.transitional(ce.boolean)
    }, !1), s != null && (g.isFunction(s) ? n.paramsSerializer = {
      serialize: s
    } : Tt.assertOptions(s, {
      encode: ce.function,
      serialize: ce.function
    }, !0)), n.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? n.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : n.allowAbsoluteUrls = !0), Tt.assertOptions(n, {
      baseUrl: ce.spelling("baseURL"),
      withXsrfToken: ce.spelling("withXSRFToken")
    }, !0), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let o = i && g.merge(
      i.common,
      i[n.method]
    );
    i && g.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (_) => {
        delete i[_];
      }
    ), n.headers = Q.concat(o, i);
    const a = [];
    let u = !0;
    this.interceptors.request.forEach(function(b) {
      typeof b.runWhen == "function" && b.runWhen(n) === !1 || (u = u && b.synchronous, a.unshift(b.fulfilled, b.rejected));
    });
    const l = [];
    this.interceptors.response.forEach(function(b) {
      l.push(b.fulfilled, b.rejected);
    });
    let d, h = 0, w;
    if (!u) {
      const _ = [Vn.bind(this), void 0];
      for (_.unshift.apply(_, a), _.push.apply(_, l), w = _.length, d = Promise.resolve(n); h < w; )
        d = d.then(_[h++], _[h++]);
      return d;
    }
    w = a.length;
    let R = n;
    for (h = 0; h < w; ) {
      const _ = a[h++], b = a[h++];
      try {
        R = _(R);
      } catch (O) {
        b.call(this, O);
        break;
      }
    }
    try {
      d = Vn.call(this, R);
    } catch (_) {
      return Promise.reject(_);
    }
    for (h = 0, w = l.length; h < w; )
      d = d.then(l[h++], l[h++]);
    return d;
  }
  getUri(t) {
    t = Me(this.defaults, t);
    const n = Gr(t.baseURL, t.url, t.allowAbsoluteUrls);
    return qr(n, t.params, t.paramsSerializer);
  }
};
g.forEach(["delete", "get", "head", "options"], function(t) {
  Ie.prototype[t] = function(n, r) {
    return this.request(Me(r || {}, {
      method: t,
      url: n,
      data: (r || {}).data
    }));
  };
});
g.forEach(["post", "put", "patch"], function(t) {
  function n(r) {
    return function(i, o, a) {
      return this.request(Me(a || {}, {
        method: t,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: o
      }));
    };
  }
  Ie.prototype[t] = n(), Ie.prototype[t + "Form"] = n(!0);
});
let zo = class es {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(i) {
      n = i;
    });
    const r = this;
    this.promise.then((s) => {
      if (!r._listeners) return;
      let i = r._listeners.length;
      for (; i-- > 0; )
        r._listeners[i](s);
      r._listeners = null;
    }), this.promise.then = (s) => {
      let i;
      const o = new Promise((a) => {
        r.subscribe(a), i = a;
      }).then(s);
      return o.cancel = function() {
        r.unsubscribe(i);
      }, o;
    }, t(function(i, o, a) {
      r.reason || (r.reason = new Ye(i, o, a), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), n = (r) => {
      t.abort(r);
    };
    return this.subscribe(n), t.signal.unsubscribe = () => this.unsubscribe(n), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new es(function(s) {
        t = s;
      }),
      cancel: t
    };
  }
};
function Yo(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function Vo(e) {
  return g.isObject(e) && e.isAxiosError === !0;
}
const ln = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(ln).forEach(([e, t]) => {
  ln[t] = e;
});
function ts(e) {
  const t = new Ie(e), n = Nr(Ie.prototype.request, t);
  return g.extend(n, Ie.prototype, t, { allOwnKeys: !0 }), g.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(s) {
    return ts(Me(e, s));
  }, n;
}
const z = ts(ft);
z.Axios = Ie;
z.CanceledError = Ye;
z.CancelToken = zo;
z.isCancel = Yr;
z.VERSION = Qr;
z.toFormData = Lt;
z.AxiosError = N;
z.Cancel = z.CanceledError;
z.all = function(t) {
  return Promise.all(t);
};
z.spread = Yo;
z.isAxiosError = Vo;
z.mergeConfig = Me;
z.AxiosHeaders = Q;
z.formToJSON = (e) => zr(g.isHTMLForm(e) ? new FormData(e) : e);
z.getAdapter = Zr.getAdapter;
z.HttpStatusCode = ln;
z.default = z;
const {
  Axios: Oh,
  AxiosError: Ch,
  CanceledError: Rh,
  isCancel: kh,
  CancelToken: Ah,
  VERSION: Ph,
  all: xh,
  Cancel: Nh,
  isAxiosError: Lh,
  spread: Dh,
  toFormData: Ih,
  AxiosHeaders: Mh,
  HttpStatusCode: jh,
  formToJSON: $h,
  getAdapter: Uh,
  mergeConfig: Fh
} = z, Go = /* @__PURE__ */ new Set([
  "ENOTFOUND",
  "ENETUNREACH",
  // SSL errors from https://github.com/nodejs/node/blob/fc8e3e2cdc521978351de257030db0076d79e0ab/src/crypto/crypto_common.cc#L301-L328
  "UNABLE_TO_GET_ISSUER_CERT",
  "UNABLE_TO_GET_CRL",
  "UNABLE_TO_DECRYPT_CERT_SIGNATURE",
  "UNABLE_TO_DECRYPT_CRL_SIGNATURE",
  "UNABLE_TO_DECODE_ISSUER_PUBLIC_KEY",
  "CERT_SIGNATURE_FAILURE",
  "CRL_SIGNATURE_FAILURE",
  "CERT_NOT_YET_VALID",
  "CERT_HAS_EXPIRED",
  "CRL_NOT_YET_VALID",
  "CRL_HAS_EXPIRED",
  "ERROR_IN_CERT_NOT_BEFORE_FIELD",
  "ERROR_IN_CERT_NOT_AFTER_FIELD",
  "ERROR_IN_CRL_LAST_UPDATE_FIELD",
  "ERROR_IN_CRL_NEXT_UPDATE_FIELD",
  "OUT_OF_MEM",
  "DEPTH_ZERO_SELF_SIGNED_CERT",
  "SELF_SIGNED_CERT_IN_CHAIN",
  "UNABLE_TO_GET_ISSUER_CERT_LOCALLY",
  "UNABLE_TO_VERIFY_LEAF_SIGNATURE",
  "CERT_CHAIN_TOO_LONG",
  "CERT_REVOKED",
  "INVALID_CA",
  "PATH_LENGTH_EXCEEDED",
  "INVALID_PURPOSE",
  "CERT_UNTRUSTED",
  "CERT_REJECTED",
  "HOSTNAME_MISMATCH"
]);
var Ko = (e) => !Go.has(e && e.code);
const Jo = /* @__PURE__ */ Pr(Ko);
function Kn(e, t, n, r, s, i, o) {
  try {
    var a = e[i](o), u = a.value;
  } catch (l) {
    n(l);
    return;
  }
  a.done ? t(u) : Promise.resolve(u).then(r, s);
}
function ns(e) {
  return function() {
    var t = this, n = arguments;
    return new Promise(function(r, s) {
      var i = e.apply(t, n);
      function o(u) {
        Kn(i, r, s, o, a, "next", u);
      }
      function a(u) {
        Kn(i, r, s, o, a, "throw", u);
      }
      o(void 0);
    });
  };
}
function Jn(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Kt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Jn(Object(n), !0).forEach(function(r) {
      Xo(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Jn(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Xo(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var rs = "axios-retry";
function ss(e) {
  var t = ["ERR_CANCELED", "ECONNABORTED"];
  return !e.response && !!e.code && // Prevents retrying cancelled requests
  !t.includes(e.code) && // Prevents retrying timed out & cancelled requests
  Jo(e);
}
var is = ["get", "head", "options"], Zo = is.concat(["put", "delete"]);
function En(e) {
  return e.code !== "ECONNABORTED" && (!e.response || e.response.status >= 500 && e.response.status <= 599);
}
function Qo(e) {
  return e.config ? En(e) && is.indexOf(e.config.method) !== -1 : !1;
}
function os(e) {
  return e.config ? En(e) && Zo.indexOf(e.config.method) !== -1 : !1;
}
function as(e) {
  return ss(e) || os(e);
}
function ea() {
  return 0;
}
function ta() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 100, n = Math.pow(2, e) * t, r = n * 0.2 * Math.random();
  return n + r;
}
var na = {
  retries: 3,
  retryCondition: as,
  retryDelay: ea,
  shouldResetTimeout: !1,
  onRetry: () => {
  }
};
function ra(e, t) {
  return Kt(Kt(Kt({}, na), t), e[rs]);
}
function Xn(e, t) {
  var n = ra(e, t);
  return n.retryCount = n.retryCount || 0, e[rs] = n, n;
}
function sa(e, t) {
  e.defaults.agent === t.agent && delete t.agent, e.defaults.httpAgent === t.httpAgent && delete t.httpAgent, e.defaults.httpsAgent === t.httpsAgent && delete t.httpsAgent;
}
function ia(e, t) {
  return fn.apply(this, arguments);
}
function fn() {
  return fn = ns(function* (e, t) {
    var {
      retries: n,
      retryCondition: r
    } = e, s = e.retryCount < n && r(t);
    if (typeof s == "object")
      try {
        var i = yield s;
        return i !== !1;
      } catch {
        return !1;
      }
    return s;
  }), fn.apply(this, arguments);
}
function ge(e, t) {
  var n = e.interceptors.request.use((s) => {
    var i = Xn(s, t);
    return i.lastRequestTime = Date.now(), s;
  }), r = e.interceptors.response.use(null, /* @__PURE__ */ function() {
    var s = ns(function* (i) {
      var {
        config: o
      } = i;
      if (!o)
        return Promise.reject(i);
      var a = Xn(o, t);
      if (yield ia(a, i)) {
        a.retryCount += 1;
        var {
          retryDelay: u,
          shouldResetTimeout: l,
          onRetry: d
        } = a, h = u(a.retryCount, i);
        if (sa(e, o), !l && o.timeout && a.lastRequestTime) {
          var w = Date.now() - a.lastRequestTime, R = o.timeout - w - h;
          if (R <= 0)
            return Promise.reject(i);
          o.timeout = R;
        }
        return o.transformRequest = [(_) => _], yield d(a.retryCount, i, o), new Promise((_) => setTimeout(() => _(e(o)), h));
      }
      return Promise.reject(i);
    });
    return function(i) {
      return s.apply(this, arguments);
    };
  }());
  return {
    requestInterceptorId: n,
    responseInterceptorId: r
  };
}
ge.isNetworkError = ss;
ge.isSafeRequestError = Qo;
ge.isIdempotentRequestError = os;
ge.isNetworkOrIdempotentRequestError = as;
ge.exponentialDelay = ta;
ge.isRetryableError = En;
var rt = (e) => typeof e == "function" ? e : function() {
  return e;
}, oa = typeof self < "u" ? self : null, nt = typeof window < "u" ? window : null, st = oa || nt || st, aa = "2.0.0", le = { connecting: 0, open: 1, closing: 2, closed: 3 }, ca = 1e4, ua = 1e3, ee = {
  closed: "closed",
  errored: "errored",
  joined: "joined",
  joining: "joining",
  leaving: "leaving"
}, me = {
  close: "phx_close",
  error: "phx_error",
  join: "phx_join",
  reply: "phx_reply",
  leave: "phx_leave"
}, dn = {
  longpoll: "longpoll",
  websocket: "websocket"
}, la = {
  complete: 4
}, pt = class {
  constructor(e, t, n, r) {
    this.channel = e, this.event = t, this.payload = n || function() {
      return {};
    }, this.receivedResp = null, this.timeout = r, this.timeoutTimer = null, this.recHooks = [], this.sent = !1;
  }
  resend(e) {
    this.timeout = e, this.reset(), this.send();
  }
  send() {
    this.hasReceived("timeout") || (this.startTimeout(), this.sent = !0, this.channel.socket.push({
      topic: this.channel.topic,
      event: this.event,
      payload: this.payload(),
      ref: this.ref,
      join_ref: this.channel.joinRef()
    }));
  }
  receive(e, t) {
    return this.hasReceived(e) && t(this.receivedResp.response), this.recHooks.push({ status: e, callback: t }), this;
  }
  reset() {
    this.cancelRefEvent(), this.ref = null, this.refEvent = null, this.receivedResp = null, this.sent = !1;
  }
  matchReceive({ status: e, response: t, _ref: n }) {
    this.recHooks.filter((r) => r.status === e).forEach((r) => r.callback(t));
  }
  cancelRefEvent() {
    this.refEvent && this.channel.off(this.refEvent);
  }
  cancelTimeout() {
    clearTimeout(this.timeoutTimer), this.timeoutTimer = null;
  }
  startTimeout() {
    this.timeoutTimer && this.cancelTimeout(), this.ref = this.channel.socket.makeRef(), this.refEvent = this.channel.replyEventName(this.ref), this.channel.on(this.refEvent, (e) => {
      this.cancelRefEvent(), this.cancelTimeout(), this.receivedResp = e, this.matchReceive(e);
    }), this.timeoutTimer = setTimeout(() => {
      this.trigger("timeout", {});
    }, this.timeout);
  }
  hasReceived(e) {
    return this.receivedResp && this.receivedResp.status === e;
  }
  trigger(e, t) {
    this.channel.trigger(this.refEvent, { status: e, response: t });
  }
}, cs = class {
  constructor(e, t) {
    this.callback = e, this.timerCalc = t, this.timer = null, this.tries = 0;
  }
  reset() {
    this.tries = 0, clearTimeout(this.timer);
  }
  scheduleTimeout() {
    clearTimeout(this.timer), this.timer = setTimeout(() => {
      this.tries = this.tries + 1, this.callback();
    }, this.timerCalc(this.tries + 1));
  }
}, fa = class {
  constructor(e, t, n) {
    this.state = ee.closed, this.topic = e, this.params = rt(t || {}), this.socket = n, this.bindings = [], this.bindingRef = 0, this.timeout = this.socket.timeout, this.joinedOnce = !1, this.joinPush = new pt(this, me.join, this.params, this.timeout), this.pushBuffer = [], this.stateChangeRefs = [], this.rejoinTimer = new cs(() => {
      this.socket.isConnected() && this.rejoin();
    }, this.socket.rejoinAfterMs), this.stateChangeRefs.push(this.socket.onError(() => this.rejoinTimer.reset())), this.stateChangeRefs.push(this.socket.onOpen(() => {
      this.rejoinTimer.reset(), this.isErrored() && this.rejoin();
    })), this.joinPush.receive("ok", () => {
      this.state = ee.joined, this.rejoinTimer.reset(), this.pushBuffer.forEach((r) => r.send()), this.pushBuffer = [];
    }), this.joinPush.receive("error", () => {
      this.state = ee.errored, this.socket.isConnected() && this.rejoinTimer.scheduleTimeout();
    }), this.onClose(() => {
      this.rejoinTimer.reset(), this.socket.hasLogger() && this.socket.log("channel", `close ${this.topic} ${this.joinRef()}`), this.state = ee.closed, this.socket.remove(this);
    }), this.onError((r) => {
      this.socket.hasLogger() && this.socket.log("channel", `error ${this.topic}`, r), this.isJoining() && this.joinPush.reset(), this.state = ee.errored, this.socket.isConnected() && this.rejoinTimer.scheduleTimeout();
    }), this.joinPush.receive("timeout", () => {
      this.socket.hasLogger() && this.socket.log("channel", `timeout ${this.topic} (${this.joinRef()})`, this.joinPush.timeout), new pt(this, me.leave, rt({}), this.timeout).send(), this.state = ee.errored, this.joinPush.reset(), this.socket.isConnected() && this.rejoinTimer.scheduleTimeout();
    }), this.on(me.reply, (r, s) => {
      this.trigger(this.replyEventName(s), r);
    });
  }
  join(e = this.timeout) {
    if (this.joinedOnce)
      throw new Error("tried to join multiple times. 'join' can only be called a single time per channel instance");
    return this.timeout = e, this.joinedOnce = !0, this.rejoin(), this.joinPush;
  }
  onClose(e) {
    this.on(me.close, e);
  }
  onError(e) {
    return this.on(me.error, (t) => e(t));
  }
  on(e, t) {
    let n = this.bindingRef++;
    return this.bindings.push({ event: e, ref: n, callback: t }), n;
  }
  off(e, t) {
    this.bindings = this.bindings.filter((n) => !(n.event === e && (typeof t > "u" || t === n.ref)));
  }
  canPush() {
    return this.socket.isConnected() && this.isJoined();
  }
  push(e, t, n = this.timeout) {
    if (t = t || {}, !this.joinedOnce)
      throw new Error(`tried to push '${e}' to '${this.topic}' before joining. Use channel.join() before pushing events`);
    let r = new pt(this, e, function() {
      return t;
    }, n);
    return this.canPush() ? r.send() : (r.startTimeout(), this.pushBuffer.push(r)), r;
  }
  leave(e = this.timeout) {
    this.rejoinTimer.reset(), this.joinPush.cancelTimeout(), this.state = ee.leaving;
    let t = () => {
      this.socket.hasLogger() && this.socket.log("channel", `leave ${this.topic}`), this.trigger(me.close, "leave");
    }, n = new pt(this, me.leave, rt({}), e);
    return n.receive("ok", () => t()).receive("timeout", () => t()), n.send(), this.canPush() || n.trigger("ok", {}), n;
  }
  onMessage(e, t, n) {
    return t;
  }
  isMember(e, t, n, r) {
    return this.topic !== e ? !1 : r && r !== this.joinRef() ? (this.socket.hasLogger() && this.socket.log("channel", "dropping outdated message", { topic: e, event: t, payload: n, joinRef: r }), !1) : !0;
  }
  joinRef() {
    return this.joinPush.ref;
  }
  rejoin(e = this.timeout) {
    this.isLeaving() || (this.socket.leaveOpenTopic(this.topic), this.state = ee.joining, this.joinPush.resend(e));
  }
  trigger(e, t, n, r) {
    let s = this.onMessage(e, t, n, r);
    if (t && !s)
      throw new Error("channel onMessage callbacks must return the payload, modified or unmodified");
    let i = this.bindings.filter((o) => o.event === e);
    for (let o = 0; o < i.length; o++)
      i[o].callback(s, n, r || this.joinRef());
  }
  replyEventName(e) {
    return `chan_reply_${e}`;
  }
  isClosed() {
    return this.state === ee.closed;
  }
  isErrored() {
    return this.state === ee.errored;
  }
  isJoined() {
    return this.state === ee.joined;
  }
  isJoining() {
    return this.state === ee.joining;
  }
  isLeaving() {
    return this.state === ee.leaving;
  }
}, Ct = class {
  static request(e, t, n, r, s, i, o) {
    if (st.XDomainRequest) {
      let a = new st.XDomainRequest();
      return this.xdomainRequest(a, e, t, r, s, i, o);
    } else {
      let a = new st.XMLHttpRequest();
      return this.xhrRequest(a, e, t, n, r, s, i, o);
    }
  }
  static xdomainRequest(e, t, n, r, s, i, o) {
    return e.timeout = s, e.open(t, n), e.onload = () => {
      let a = this.parseJSON(e.responseText);
      o && o(a);
    }, i && (e.ontimeout = i), e.onprogress = () => {
    }, e.send(r), e;
  }
  static xhrRequest(e, t, n, r, s, i, o, a) {
    return e.open(t, n, !0), e.timeout = i, e.setRequestHeader("Content-Type", r), e.onerror = () => a && a(null), e.onreadystatechange = () => {
      if (e.readyState === la.complete && a) {
        let u = this.parseJSON(e.responseText);
        a(u);
      }
    }, o && (e.ontimeout = o), e.send(s), e;
  }
  static parseJSON(e) {
    if (!e || e === "")
      return null;
    try {
      return JSON.parse(e);
    } catch {
      return console && console.log("failed to parse JSON response", e), null;
    }
  }
  static serialize(e, t) {
    let n = [];
    for (var r in e) {
      if (!Object.prototype.hasOwnProperty.call(e, r))
        continue;
      let s = t ? `${t}[${r}]` : r, i = e[r];
      typeof i == "object" ? n.push(this.serialize(i, s)) : n.push(encodeURIComponent(s) + "=" + encodeURIComponent(i));
    }
    return n.join("&");
  }
  static appendParams(e, t) {
    if (Object.keys(t).length === 0)
      return e;
    let n = e.match(/\?/) ? "&" : "?";
    return `${e}${n}${this.serialize(t)}`;
  }
}, Jt = class {
  constructor(e) {
    this.endPoint = null, this.token = null, this.skipHeartbeat = !0, this.reqs = /* @__PURE__ */ new Set(), this.onopen = function() {
    }, this.onerror = function() {
    }, this.onmessage = function() {
    }, this.onclose = function() {
    }, this.pollEndpoint = this.normalizeEndpoint(e), this.readyState = le.connecting, this.poll();
  }
  normalizeEndpoint(e) {
    return e.replace("ws://", "http://").replace("wss://", "https://").replace(new RegExp("(.*)/" + dn.websocket), "$1/" + dn.longpoll);
  }
  endpointURL() {
    return Ct.appendParams(this.pollEndpoint, { token: this.token });
  }
  closeAndRetry(e, t, n) {
    this.close(e, t, n), this.readyState = le.connecting;
  }
  ontimeout() {
    this.onerror("timeout"), this.closeAndRetry(1005, "timeout", !1);
  }
  isActive() {
    return this.readyState === le.open || this.readyState === le.connecting;
  }
  poll() {
    this.ajax("GET", null, () => this.ontimeout(), (e) => {
      if (e) {
        var { status: t, token: n, messages: r } = e;
        this.token = n;
      } else
        t = 0;
      switch (t) {
        case 200:
          r.forEach((s) => {
            setTimeout(() => this.onmessage({ data: s }), 0);
          }), this.poll();
          break;
        case 204:
          this.poll();
          break;
        case 410:
          this.readyState = le.open, this.onopen({}), this.poll();
          break;
        case 403:
          this.onerror(403), this.close(1008, "forbidden", !1);
          break;
        case 0:
        case 500:
          this.onerror(500), this.closeAndRetry(1011, "internal server error", 500);
          break;
        default:
          throw new Error(`unhandled poll status ${t}`);
      }
    });
  }
  send(e) {
    this.ajax("POST", e, () => this.onerror("timeout"), (t) => {
      (!t || t.status !== 200) && (this.onerror(t && t.status), this.closeAndRetry(1011, "internal server error", !1));
    });
  }
  close(e, t, n) {
    for (let s of this.reqs)
      s.abort();
    this.readyState = le.closed;
    let r = Object.assign({ code: 1e3, reason: void 0, wasClean: !0 }, { code: e, reason: t, wasClean: n });
    typeof CloseEvent < "u" ? this.onclose(new CloseEvent("close", r)) : this.onclose(r);
  }
  ajax(e, t, n, r) {
    let s, i = () => {
      this.reqs.delete(s), n();
    };
    s = Ct.request(e, this.endpointURL(), "application/json", t, this.timeout, i, (o) => {
      this.reqs.delete(s), this.isActive() && r(o);
    }), this.reqs.add(s);
  }
}, gt = {
  HEADER_LENGTH: 1,
  META_LENGTH: 4,
  KINDS: { push: 0, reply: 1, broadcast: 2 },
  encode(e, t) {
    if (e.payload.constructor === ArrayBuffer)
      return t(this.binaryEncode(e));
    {
      let n = [e.join_ref, e.ref, e.topic, e.event, e.payload];
      return t(JSON.stringify(n));
    }
  },
  decode(e, t) {
    if (e.constructor === ArrayBuffer)
      return t(this.binaryDecode(e));
    {
      let [n, r, s, i, o] = JSON.parse(e);
      return t({ join_ref: n, ref: r, topic: s, event: i, payload: o });
    }
  },
  binaryEncode(e) {
    let { join_ref: t, ref: n, event: r, topic: s, payload: i } = e, o = this.META_LENGTH + t.length + n.length + s.length + r.length, a = new ArrayBuffer(this.HEADER_LENGTH + o), u = new DataView(a), l = 0;
    u.setUint8(l++, this.KINDS.push), u.setUint8(l++, t.length), u.setUint8(l++, n.length), u.setUint8(l++, s.length), u.setUint8(l++, r.length), Array.from(t, (h) => u.setUint8(l++, h.charCodeAt(0))), Array.from(n, (h) => u.setUint8(l++, h.charCodeAt(0))), Array.from(s, (h) => u.setUint8(l++, h.charCodeAt(0))), Array.from(r, (h) => u.setUint8(l++, h.charCodeAt(0)));
    var d = new Uint8Array(a.byteLength + i.byteLength);
    return d.set(new Uint8Array(a), 0), d.set(new Uint8Array(i), a.byteLength), d.buffer;
  },
  binaryDecode(e) {
    let t = new DataView(e), n = t.getUint8(0), r = new TextDecoder();
    switch (n) {
      case this.KINDS.push:
        return this.decodePush(e, t, r);
      case this.KINDS.reply:
        return this.decodeReply(e, t, r);
      case this.KINDS.broadcast:
        return this.decodeBroadcast(e, t, r);
    }
  },
  decodePush(e, t, n) {
    let r = t.getUint8(1), s = t.getUint8(2), i = t.getUint8(3), o = this.HEADER_LENGTH + this.META_LENGTH - 1, a = n.decode(e.slice(o, o + r));
    o = o + r;
    let u = n.decode(e.slice(o, o + s));
    o = o + s;
    let l = n.decode(e.slice(o, o + i));
    o = o + i;
    let d = e.slice(o, e.byteLength);
    return { join_ref: a, ref: null, topic: u, event: l, payload: d };
  },
  decodeReply(e, t, n) {
    let r = t.getUint8(1), s = t.getUint8(2), i = t.getUint8(3), o = t.getUint8(4), a = this.HEADER_LENGTH + this.META_LENGTH, u = n.decode(e.slice(a, a + r));
    a = a + r;
    let l = n.decode(e.slice(a, a + s));
    a = a + s;
    let d = n.decode(e.slice(a, a + i));
    a = a + i;
    let h = n.decode(e.slice(a, a + o));
    a = a + o;
    let w = e.slice(a, e.byteLength), R = { status: h, response: w };
    return { join_ref: u, ref: l, topic: d, event: me.reply, payload: R };
  },
  decodeBroadcast(e, t, n) {
    let r = t.getUint8(1), s = t.getUint8(2), i = this.HEADER_LENGTH + 2, o = n.decode(e.slice(i, i + r));
    i = i + r;
    let a = n.decode(e.slice(i, i + s));
    i = i + s;
    let u = e.slice(i, e.byteLength);
    return { join_ref: null, ref: null, topic: o, event: a, payload: u };
  }
}, da = class {
  constructor(e, t = {}) {
    this.stateChangeCallbacks = { open: [], close: [], error: [], message: [] }, this.channels = [], this.sendBuffer = [], this.ref = 0, this.timeout = t.timeout || ca, this.transport = t.transport || st.WebSocket || Jt, this.establishedConnections = 0, this.defaultEncoder = gt.encode.bind(gt), this.defaultDecoder = gt.decode.bind(gt), this.closeWasClean = !1, this.binaryType = t.binaryType || "arraybuffer", this.connectClock = 1, this.transport !== Jt ? (this.encode = t.encode || this.defaultEncoder, this.decode = t.decode || this.defaultDecoder) : (this.encode = this.defaultEncoder, this.decode = this.defaultDecoder);
    let n = null;
    nt && nt.addEventListener && (nt.addEventListener("pagehide", (r) => {
      this.conn && (this.disconnect(), n = this.connectClock);
    }), nt.addEventListener("pageshow", (r) => {
      n === this.connectClock && (n = null, this.connect());
    })), this.heartbeatIntervalMs = t.heartbeatIntervalMs || 3e4, this.rejoinAfterMs = (r) => t.rejoinAfterMs ? t.rejoinAfterMs(r) : [1e3, 2e3, 5e3][r - 1] || 1e4, this.reconnectAfterMs = (r) => t.reconnectAfterMs ? t.reconnectAfterMs(r) : [10, 50, 100, 150, 200, 250, 500, 1e3, 2e3][r - 1] || 5e3, this.logger = t.logger || null, this.longpollerTimeout = t.longpollerTimeout || 2e4, this.params = rt(t.params || {}), this.endPoint = `${e}/${dn.websocket}`, this.vsn = t.vsn || aa, this.heartbeatTimeoutTimer = null, this.heartbeatTimer = null, this.pendingHeartbeatRef = null, this.reconnectTimer = new cs(() => {
      this.teardown(() => this.connect());
    }, this.reconnectAfterMs);
  }
  getLongPollTransport() {
    return Jt;
  }
  replaceTransport(e) {
    this.connectClock++, this.closeWasClean = !0, this.reconnectTimer.reset(), this.sendBuffer = [], this.conn && (this.conn.close(), this.conn = null), this.transport = e;
  }
  protocol() {
    return location.protocol.match(/^https/) ? "wss" : "ws";
  }
  endPointURL() {
    let e = Ct.appendParams(Ct.appendParams(this.endPoint, this.params()), { vsn: this.vsn });
    return e.charAt(0) !== "/" ? e : e.charAt(1) === "/" ? `${this.protocol()}:${e}` : `${this.protocol()}://${location.host}${e}`;
  }
  disconnect(e, t, n) {
    this.connectClock++, this.closeWasClean = !0, this.reconnectTimer.reset(), this.teardown(e, t, n);
  }
  connect(e) {
    e && (console && console.log("passing params to connect is deprecated. Instead pass :params to the Socket constructor"), this.params = rt(e)), !this.conn && (this.connectClock++, this.closeWasClean = !1, this.conn = new this.transport(this.endPointURL()), this.conn.binaryType = this.binaryType, this.conn.timeout = this.longpollerTimeout, this.conn.onopen = () => this.onConnOpen(), this.conn.onerror = (t) => this.onConnError(t), this.conn.onmessage = (t) => this.onConnMessage(t), this.conn.onclose = (t) => this.onConnClose(t));
  }
  log(e, t, n) {
    this.logger(e, t, n);
  }
  hasLogger() {
    return this.logger !== null;
  }
  onOpen(e) {
    let t = this.makeRef();
    return this.stateChangeCallbacks.open.push([t, e]), t;
  }
  onClose(e) {
    let t = this.makeRef();
    return this.stateChangeCallbacks.close.push([t, e]), t;
  }
  onError(e) {
    let t = this.makeRef();
    return this.stateChangeCallbacks.error.push([t, e]), t;
  }
  onMessage(e) {
    let t = this.makeRef();
    return this.stateChangeCallbacks.message.push([t, e]), t;
  }
  ping(e) {
    if (!this.isConnected())
      return !1;
    let t = this.makeRef(), n = Date.now();
    this.push({ topic: "phoenix", event: "heartbeat", payload: {}, ref: t });
    let r = this.onMessage((s) => {
      s.ref === t && (this.off([r]), e(Date.now() - n));
    });
    return !0;
  }
  clearHeartbeats() {
    clearTimeout(this.heartbeatTimer), clearTimeout(this.heartbeatTimeoutTimer);
  }
  onConnOpen() {
    this.hasLogger() && this.log("transport", `connected to ${this.endPointURL()}`), this.closeWasClean = !1, this.establishedConnections++, this.flushSendBuffer(), this.reconnectTimer.reset(), this.resetHeartbeat(), this.stateChangeCallbacks.open.forEach(([, e]) => e());
  }
  heartbeatTimeout() {
    this.pendingHeartbeatRef && (this.pendingHeartbeatRef = null, this.hasLogger() && this.log("transport", "heartbeat timeout. Attempting to re-establish connection"), this.triggerChanError(), this.closeWasClean = !1, this.teardown(() => this.reconnectTimer.scheduleTimeout(), ua, "heartbeat timeout"));
  }
  resetHeartbeat() {
    this.conn && this.conn.skipHeartbeat || (this.pendingHeartbeatRef = null, this.clearHeartbeats(), this.heartbeatTimer = setTimeout(() => this.sendHeartbeat(), this.heartbeatIntervalMs));
  }
  teardown(e, t, n) {
    if (!this.conn)
      return e && e();
    this.waitForBufferDone(() => {
      this.conn && (t ? this.conn.close(t, n || "") : this.conn.close()), this.waitForSocketClosed(() => {
        this.conn && (this.conn.onopen = function() {
        }, this.conn.onerror = function() {
        }, this.conn.onmessage = function() {
        }, this.conn.onclose = function() {
        }, this.conn = null), e && e();
      });
    });
  }
  waitForBufferDone(e, t = 1) {
    if (t === 5 || !this.conn || !this.conn.bufferedAmount) {
      e();
      return;
    }
    setTimeout(() => {
      this.waitForBufferDone(e, t + 1);
    }, 150 * t);
  }
  waitForSocketClosed(e, t = 1) {
    if (t === 5 || !this.conn || this.conn.readyState === le.closed) {
      e();
      return;
    }
    setTimeout(() => {
      this.waitForSocketClosed(e, t + 1);
    }, 150 * t);
  }
  onConnClose(e) {
    let t = e && e.code;
    this.hasLogger() && this.log("transport", "close", e), this.triggerChanError(), this.clearHeartbeats(), !this.closeWasClean && t !== 1e3 && this.reconnectTimer.scheduleTimeout(), this.stateChangeCallbacks.close.forEach(([, n]) => n(e));
  }
  onConnError(e) {
    this.hasLogger() && this.log("transport", e);
    let t = this.transport, n = this.establishedConnections;
    this.stateChangeCallbacks.error.forEach(([, r]) => {
      r(e, t, n);
    }), (t === this.transport || n > 0) && this.triggerChanError();
  }
  triggerChanError() {
    this.channels.forEach((e) => {
      e.isErrored() || e.isLeaving() || e.isClosed() || e.trigger(me.error);
    });
  }
  connectionState() {
    switch (this.conn && this.conn.readyState) {
      case le.connecting:
        return "connecting";
      case le.open:
        return "open";
      case le.closing:
        return "closing";
      default:
        return "closed";
    }
  }
  isConnected() {
    return this.connectionState() === "open";
  }
  remove(e) {
    this.off(e.stateChangeRefs), this.channels = this.channels.filter((t) => t.joinRef() !== e.joinRef());
  }
  off(e) {
    for (let t in this.stateChangeCallbacks)
      this.stateChangeCallbacks[t] = this.stateChangeCallbacks[t].filter(([n]) => e.indexOf(n) === -1);
  }
  channel(e, t = {}) {
    let n = new fa(e, t, this);
    return this.channels.push(n), n;
  }
  push(e) {
    if (this.hasLogger()) {
      let { topic: t, event: n, payload: r, ref: s, join_ref: i } = e;
      this.log("push", `${t} ${n} (${i}, ${s})`, r);
    }
    this.isConnected() ? this.encode(e, (t) => this.conn.send(t)) : this.sendBuffer.push(() => this.encode(e, (t) => this.conn.send(t)));
  }
  makeRef() {
    let e = this.ref + 1;
    return e === this.ref ? this.ref = 0 : this.ref = e, this.ref.toString();
  }
  sendHeartbeat() {
    this.pendingHeartbeatRef && !this.isConnected() || (this.pendingHeartbeatRef = this.makeRef(), this.push({ topic: "phoenix", event: "heartbeat", payload: {}, ref: this.pendingHeartbeatRef }), this.heartbeatTimeoutTimer = setTimeout(() => this.heartbeatTimeout(), this.heartbeatIntervalMs));
  }
  flushSendBuffer() {
    this.isConnected() && this.sendBuffer.length > 0 && (this.sendBuffer.forEach((e) => e()), this.sendBuffer = []);
  }
  onConnMessage(e) {
    this.decode(e.data, (t) => {
      let { topic: n, event: r, payload: s, ref: i, join_ref: o } = t;
      i && i === this.pendingHeartbeatRef && (this.clearHeartbeats(), this.pendingHeartbeatRef = null, this.heartbeatTimer = setTimeout(() => this.sendHeartbeat(), this.heartbeatIntervalMs)), this.hasLogger() && this.log("receive", `${s.status || ""} ${n} ${r} ${i && "(" + i + ")" || ""}`, s);
      for (let a = 0; a < this.channels.length; a++) {
        const u = this.channels[a];
        u.isMember(n, r, s, o) && u.trigger(r, s, i, o);
      }
      for (let a = 0; a < this.stateChangeCallbacks.message.length; a++) {
        let [, u] = this.stateChangeCallbacks.message[a];
        u(t);
      }
    });
  }
  leaveOpenTopic(e) {
    let t = this.channels.find((n) => n.topic === e && (n.isJoined() || n.isJoining()));
    t && (this.hasLogger() && this.log("transport", `leaving duplicate topic "${e}"`), t.leave());
  }
}, ha = Object.defineProperty, ma = (e, t, n) => t in e ? ha(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Je = (e, t, n) => (ma(e, typeof t != "symbol" ? t + "" : t, n), n);
class pa {
  constructor(t) {
    Je(this, "host"), Je(this, "apiKey"), Je(this, "userToken"), Je(this, "axiosClient"), Je(this, "socket"), this.host = t.host, this.apiKey = t.apiKey, this.userToken = t.userToken || null, this.axiosClient = z.create({
      baseURL: this.host,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.apiKey}`,
        "X-Knock-User-Token": this.userToken
      }
    }), typeof window < "u" && (this.socket = new da(`${this.host.replace("http", "ws")}/ws/v1`, {
      params: {
        user_token: this.userToken,
        api_key: this.apiKey
      }
    })), ge(this.axiosClient, {
      retries: 3,
      retryCondition: this.canRetryRequest,
      retryDelay: ge.exponentialDelay
    });
  }
  async makeRequest(t) {
    try {
      const n = await this.axiosClient(t);
      return {
        statusCode: n.status < 300 ? "ok" : "error",
        body: n.data,
        error: void 0,
        status: n.status
      };
    } catch (n) {
      return console.error(n), {
        statusCode: "error",
        status: 500,
        body: void 0,
        error: n
      };
    }
  }
  canRetryRequest(t) {
    return ge.isNetworkError(t) ? !0 : t.response ? t.response.status >= 500 && t.response.status <= 599 || t.response.status === 429 : !1;
  }
}
var ga = Object.defineProperty, ya = (e, t, n) => t in e ? ga(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, wa = (e, t, n) => (ya(e, t + "", n), n);
const Te = "default";
function Zn(e) {
  return typeof e == "object" ? e : { subscribed: e };
}
class _a {
  constructor(t) {
    wa(this, "instance"), this.instance = t;
  }
  /**
   * @deprecated Use `user.getAllPreferences()` instead
   */
  async getAll() {
    const t = await this.instance.client().makeRequest({
      method: "GET",
      url: `/v1/users/${this.instance.userId}/preferences`
    });
    return this.handleResponse(t);
  }
  /**
   * @deprecated Use `user.getPreferences()` instead
   */
  async get(t = {}) {
    const n = t.preferenceSet || Te, r = await this.instance.client().makeRequest({
      method: "GET",
      url: `/v1/users/${this.instance.userId}/preferences/${n}`
    });
    return this.handleResponse(r);
  }
  /**
   * @deprecated Use `user.setPreferences(preferenceSet, options)` instead
   */
  async set(t, n = {}) {
    const r = n.preferenceSet || Te, s = await this.instance.client().makeRequest({
      method: "PUT",
      url: `/v1/users/${this.instance.userId}/preferences/${r}`,
      data: t
    });
    return this.handleResponse(s);
  }
  /**
   * @deprecated Use `user.setPreferences(preferenceSet, options)` instead
   */
  async setChannelTypes(t, n = {}) {
    const r = n.preferenceSet || Te, s = await this.instance.client().makeRequest({
      method: "PUT",
      url: `/v1/users/${this.instance.userId}/preferences/${r}/channel_types`,
      data: t
    });
    return this.handleResponse(s);
  }
  /**
   * @deprecated Use `user.setPreferences(preferenceSet, options)` instead
   */
  async setChannelType(t, n, r = {}) {
    const s = r.preferenceSet || Te, i = await this.instance.client().makeRequest({
      method: "PUT",
      url: `/v1/users/${this.instance.userId}/preferences/${s}/channel_types/${t}`,
      data: { subscribed: n }
    });
    return this.handleResponse(i);
  }
  /**
   * @deprecated Use `user.setPreferences(preferenceSet, options)` instead
   */
  async setWorkflows(t, n = {}) {
    const r = n.preferenceSet || Te, s = await this.instance.client().makeRequest({
      method: "PUT",
      url: `/v1/users/${this.instance.userId}/preferences/${r}/workflows`,
      data: t
    });
    return this.handleResponse(s);
  }
  /**
   * @deprecated Use `user.setPreferences(preferenceSet, options)` instead
   */
  async setWorkflow(t, n, r = {}) {
    const s = r.preferenceSet || Te, i = Zn(n), o = await this.instance.client().makeRequest({
      method: "PUT",
      url: `/v1/users/${this.instance.userId}/preferences/${s}/workflows/${t}`,
      data: i
    });
    return this.handleResponse(o);
  }
  /**
   * @deprecated Use `user.setPreferences(preferenceSet, options)` instead
   */
  async setCategories(t, n = {}) {
    const r = n.preferenceSet || Te, s = await this.instance.client().makeRequest({
      method: "PUT",
      url: `/v1/users/${this.instance.userId}/preferences/${r}/categories`,
      data: t
    });
    return this.handleResponse(s);
  }
  /**
   * @deprecated Use `user.setPreferences(preferenceSet, options)` instead
   */
  async setCategory(t, n, r = {}) {
    const s = r.preferenceSet || Te, i = Zn(n), o = await this.instance.client().makeRequest({
      method: "PUT",
      url: `/v1/users/${this.instance.userId}/preferences/${s}/categories/${t}`,
      data: i
    });
    return this.handleResponse(o);
  }
  handleResponse(t) {
    if (t.statusCode === "error")
      throw new Error(t.error || t.body);
    return t.body;
  }
}
var va = Object.defineProperty, ba = (e, t, n) => t in e ? va(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Ta = (e, t, n) => (ba(e, t + "", n), n);
const Qn = "default";
let Ea = class {
  constructor(t) {
    Ta(this, "instance"), this.instance = t;
  }
  async getAllPreferences() {
    const t = await this.instance.client().makeRequest({
      method: "GET",
      url: `/v1/users/${this.instance.userId}/preferences`
    });
    return this.handleResponse(t);
  }
  async getPreferences(t = {}) {
    const n = t.preferenceSet || Qn, r = await this.instance.client().makeRequest({
      method: "GET",
      url: `/v1/users/${this.instance.userId}/preferences/${n}`,
      params: { tenant: t.tenant }
    });
    return this.handleResponse(r);
  }
  async setPreferences(t, n = {}) {
    const r = n.preferenceSet || Qn, s = await this.instance.client().makeRequest({
      method: "PUT",
      url: `/v1/users/${this.instance.userId}/preferences/${r}`,
      data: t
    });
    return this.handleResponse(s);
  }
  async getChannelData(t) {
    const n = await this.instance.client().makeRequest({
      method: "GET",
      url: `/v1/users/${this.instance.userId}/channel_data/${t.channelId}`
    });
    return this.handleResponse(n);
  }
  async setChannelData({
    channelId: t,
    channelData: n
  }) {
    const r = await this.instance.client().makeRequest({
      method: "PUT",
      url: `/v1/users/${this.instance.userId}/channel_data/${t}`,
      data: { data: n }
    });
    return this.handleResponse(r);
  }
  handleResponse(t) {
    if (t.statusCode === "error")
      throw new Error(t.error || t.body);
    return t.body;
  }
};
var Sa = Object.defineProperty, Oa = (e, t, n) => t in e ? Sa(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, he = (e, t, n) => (Oa(e, typeof t != "symbol" ? t + "" : t, n), n);
const Ca = "https://api.knock.app";
class er {
  constructor(t, n = {}) {
    if (he(this, "host"), he(this, "apiClient", null), he(this, "userId"), he(this, "userToken"), he(this, "logLevel"), he(this, "tokenExpirationTimer", null), he(this, "feeds", new mi(this)), he(this, "preferences", new _a(this)), he(this, "user", new Ea(this)), this.apiKey = t, this.host = n.host || Ca, this.logLevel = n.logLevel, this.log("Initialized Knock instance"), this.apiKey && this.apiKey.startsWith("sk_"))
      throw new Error(
        "[Knock] You are using your secret API key on the client. Please use the public key."
      );
  }
  client() {
    return this.userId || console.warn(
      `[Knock] You must call authenticate(userId, userToken) first before trying to make a request.
        Typically you'll see this message when you're creating a feed instance before having called
        authenticate with a user Id and token. That means we won't know who to issue the request
        to Knock on behalf of.
        `
    ), this.apiClient || (this.apiClient = this.createApiClient()), this.apiClient;
  }
  /*
    Authenticates the current user. In non-sandbox environments
    the userToken must be specified.
  */
  authenticate(t, n, r) {
    let s = !1;
    this.apiClient && (this.userId !== t || this.userToken !== n) && (this.log("userId or userToken changed; reinitializing connections"), this.feeds.teardownInstances(), this.teardown(), s = !0), this.userId = t, this.userToken = n, this.log(`Authenticated with userId ${t}`), this.userToken && (r == null ? void 0 : r.onUserTokenExpiring) instanceof Function && this.maybeScheduleUserTokenExpiration(
      r.onUserTokenExpiring,
      r.timeBeforeExpirationInMs
    ), s && (this.apiClient = this.createApiClient(), this.feeds.reinitializeInstances(), this.log("Reinitialized real-time connections"));
  }
  /*
    Returns whether or this Knock instance is authenticated. Passing `true` will check the presence
    of the userToken as well.
  */
  isAuthenticated(t = !1) {
    return t ? !!(this.userId && this.userToken) : !!this.userId;
  }
  // Used to teardown any connected instances
  teardown() {
    var t;
    this.tokenExpirationTimer && clearTimeout(this.tokenExpirationTimer), (t = this.apiClient) != null && t.socket && this.apiClient.socket.isConnected() && this.apiClient.socket.disconnect();
  }
  log(t) {
    this.logLevel === "debug" && console.log(`[Knock] ${t}`);
  }
  /**
   * Initiates an API client
   */
  createApiClient() {
    return new pa({
      apiKey: this.apiKey,
      host: this.host,
      userToken: this.userToken
    });
  }
  async maybeScheduleUserTokenExpiration(t, n = 3e4) {
    if (!this.userToken)
      return;
    const r = yi(this.userToken), s = (r.exp ?? 0) * 1e3, i = Date.now();
    if (s && s > i) {
      const o = s - n - i;
      this.tokenExpirationTimer = setTimeout(async () => {
        const a = await t(this.userToken, r);
        typeof a == "string" && this.authenticate(this.userId, a, {
          onUserTokenExpiring: t,
          timeBeforeExpirationInMs: n
        });
      }, o);
    }
  }
}
function Ra(e, t, n, r) {
  const s = ue(e) ? e.value : e, i = ue(t) ? t.value : t, o = ue(n) ? n.value : n, a = se();
  if (s && i) {
    const l = new er(s, r);
    l.authenticate(i, o), a.value = l;
  }
  const u = [e, t, n].map((l) => ue(l) ? l : se(l));
  return $e(u, ([l, d, h]) => {
    a.value && a.value.teardown();
    const w = ue(e) ? l : e, R = ue(t) ? d : t, _ = ue(n) ? h : o;
    if (w && R) {
      const b = new er(w, r);
      b.authenticate(R, _), a.value = b;
    }
  }), a;
}
function ka(e, t, n = {}) {
  const r = ue(t) ? t.value : t, s = se();
  if (e.value && r) {
    const o = e.value.feeds.initialize(r, n);
    s.value = o, s.value.listenForUpdates();
  }
  const i = ue(t) ? t : se(t);
  return $e([e, i], ([o, a]) => {
    s.value && s.value.teardown();
    const u = ue(t) ? a : r;
    if (o && u) {
      const l = o.feeds.initialize(u, n);
      l.listenForUpdates(), s.value = l;
    }
  }), s;
}
const Aa = 5e3, Pa = 300;
var He = /* @__PURE__ */ ((e) => (e.All = "all", e.Read = "read", e.Unseen = "unseen", e.Unread = "unread", e))(He || {});
const xa = {
  all: "All",
  unread: "Unread",
  read: "Read"
};
var V = /* @__PURE__ */ ((e) => (e.AllTabClicked = "Notification All Tab Clicked", e.ReadTabClicked = "Notification Read Tab Clicked", e.UnreadTabClicked = "Notification Unread Tab Clicked", e.MarkAllAsReadClicked = "Notification Mark All As Read Clicked", e.NotificationClicked = "Notification Clicked", e.NotificationDeleted = "Notification Deleted", e.NotificationOpenedInNewTab = "Notification Opened In New Tab", e.NotificationOpenedWithKeyboardModifier = "Notification Opened With Keyboard Modifier", e.NotificationMarkedAsRead = "Notification Marked As Read", e.NotificationMarkedAsUnread = "Notification Marked As Unread", e.NotificationsOpened = "Notifications Opened", e.NotificationsClosed = "Notifications Closed", e.NotificationDismissed = "Notification Dismissed", e.NotificationPreferencesClick = "Notification Preferences Clicked", e))(V || {});
const Sn = Symbol("knock"), Na = { class: "vnf-feed-provider" }, Hh = /* @__PURE__ */ K({
  __name: "KnockFeedProvider",
  props: {
    apiKey: {},
    feedId: {},
    userId: {},
    userToken: { default: void 0 },
    host: { default: void 0 },
    user: { default: null },
    defaultFeedOptions: { default: void 0 }
  },
  emits: ["event"],
  setup(e) {
    const t = e, n = { host: t.host }, r = Ra(
      qe(t, "apiKey"),
      qe(t, "userId"),
      qe(t, "userToken"),
      n
    ), s = ka(r, qe(t, "feedId"), t.defaultFeedOptions), i = Fs({
      items: [],
      metadata: { unseen_count: 0, unread_count: 0, total_count: 0 },
      pageInfo: { before: null, after: null, page_size: 0 },
      loading: !1,
      networkStatus: Ce.loading
    });
    $e(
      s,
      () => {
        s.value && s.value.store.subscribe((u) => {
          i.items = u.items, i.metadata = u.metadata, i.pageInfo = u.pageInfo, i.loading = u.loading, i.networkStatus = u.networkStatus;
        });
      },
      { immediate: !0 }
    );
    const o = kr();
    return Bs(Sn, {
      knock: r,
      feedClient: s,
      useFeedStore: () => i,
      colorMode: "light",
      emitNotificationEvent: async (u, l) => {
        if (!o.onNotificationEvent)
          return;
        const d = o.onNotificationEvent;
        await d(u, l);
      }
    }), (u, l) => (D(), q("div", Na, [
      wn(u.$slots, "default")
    ]));
  }
});
function Pe() {
  return Ar(Sn);
}
function re(e) {
  const t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || t === "[object Number]" || typeof e == "string" || t === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function ke(e, t) {
  return e instanceof Date ? new e.constructor(t) : new Date(t);
}
const us = 6048e5, La = 864e5, ls = 6e4, fs = 36e5;
let Da = {};
function dt() {
  return Da;
}
function at(e, t) {
  var a, u, l, d;
  const n = dt(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((u = (a = t == null ? void 0 : t.locale) == null ? void 0 : a.options) == null ? void 0 : u.weekStartsOn) ?? n.weekStartsOn ?? ((d = (l = n.locale) == null ? void 0 : l.options) == null ? void 0 : d.weekStartsOn) ?? 0, s = re(e), i = s.getDay(), o = (i < r ? 7 : 0) + i - r;
  return s.setDate(s.getDate() - o), s.setHours(0, 0, 0, 0), s;
}
function Rt(e) {
  return at(e, { weekStartsOn: 1 });
}
function ds(e) {
  const t = re(e), n = t.getFullYear(), r = ke(e, 0);
  r.setFullYear(n + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const s = Rt(r), i = ke(e, 0);
  i.setFullYear(n, 0, 4), i.setHours(0, 0, 0, 0);
  const o = Rt(i);
  return t.getTime() >= s.getTime() ? n + 1 : t.getTime() >= o.getTime() ? n : n - 1;
}
function kt(e) {
  const t = re(e);
  return t.setHours(0, 0, 0, 0), t;
}
function tr(e) {
  const t = re(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function hs(e, t) {
  const n = kt(e), r = kt(t), s = +n - tr(n), i = +r - tr(r);
  return Math.round((s - i) / La);
}
function Ia(e) {
  const t = ds(e), n = ke(e, 0);
  return n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0), Rt(n);
}
function Ma(e) {
  return ke(e, Date.now());
}
function ja(e, t) {
  const n = kt(e), r = kt(t);
  return +n == +r;
}
function $a(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Ua(e) {
  if (!$a(e) && typeof e != "number")
    return !1;
  const t = re(e);
  return !isNaN(Number(t));
}
function Fa(e) {
  const t = re(e), n = ke(e, 0);
  return n.setFullYear(t.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
const Ba = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Ha = (e, t, n) => {
  let r;
  const s = Ba[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function Xt(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const qa = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Wa = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, za = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Ya = {
  date: Xt({
    formats: qa,
    defaultWidth: "full"
  }),
  time: Xt({
    formats: Wa,
    defaultWidth: "full"
  }),
  dateTime: Xt({
    formats: za,
    defaultWidth: "full"
  })
}, Va = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Ga = (e, t, n, r) => Va[e];
function Xe(e) {
  return (t, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let s;
    if (r === "formatting" && e.formattingValues) {
      const o = e.defaultFormattingWidth || e.defaultWidth, a = n != null && n.width ? String(n.width) : o;
      s = e.formattingValues[a] || e.formattingValues[o];
    } else {
      const o = e.defaultWidth, a = n != null && n.width ? String(n.width) : e.defaultWidth;
      s = e.values[a] || e.values[o];
    }
    const i = e.argumentCallback ? e.argumentCallback(t) : t;
    return s[i];
  };
}
const Ka = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Ja = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Xa = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Za = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, Qa = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, ec = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, tc = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, nc = {
  ordinalNumber: tc,
  era: Xe({
    values: Ka,
    defaultWidth: "wide"
  }),
  quarter: Xe({
    values: Ja,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Xe({
    values: Xa,
    defaultWidth: "wide"
  }),
  day: Xe({
    values: Za,
    defaultWidth: "wide"
  }),
  dayPeriod: Xe({
    values: Qa,
    defaultWidth: "wide",
    formattingValues: ec,
    defaultFormattingWidth: "wide"
  })
};
function Ze(e) {
  return (t, n = {}) => {
    const r = n.width, s = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], i = t.match(s);
    if (!i)
      return null;
    const o = i[0], a = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], u = Array.isArray(a) ? sc(a, (h) => h.test(o)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      rc(a, (h) => h.test(o))
    );
    let l;
    l = e.valueCallback ? e.valueCallback(u) : u, l = n.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      n.valueCallback(l)
    ) : l;
    const d = t.slice(o.length);
    return { value: l, rest: d };
  };
}
function rc(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function sc(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function ic(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r) return null;
    const s = r[0], i = t.match(e.parsePattern);
    if (!i) return null;
    let o = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    o = n.valueCallback ? n.valueCallback(o) : o;
    const a = t.slice(s.length);
    return { value: o, rest: a };
  };
}
const oc = /^(\d+)(th|st|nd|rd)?/i, ac = /\d+/i, cc = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, uc = {
  any: [/^b/i, /^(a|c)/i]
}, lc = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, fc = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, dc = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, hc = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, mc = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, pc = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, gc = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, yc = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, wc = {
  ordinalNumber: ic({
    matchPattern: oc,
    parsePattern: ac,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ze({
    matchPatterns: cc,
    defaultMatchWidth: "wide",
    parsePatterns: uc,
    defaultParseWidth: "any"
  }),
  quarter: Ze({
    matchPatterns: lc,
    defaultMatchWidth: "wide",
    parsePatterns: fc,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ze({
    matchPatterns: dc,
    defaultMatchWidth: "wide",
    parsePatterns: hc,
    defaultParseWidth: "any"
  }),
  day: Ze({
    matchPatterns: mc,
    defaultMatchWidth: "wide",
    parsePatterns: pc,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ze({
    matchPatterns: gc,
    defaultMatchWidth: "any",
    parsePatterns: yc,
    defaultParseWidth: "any"
  })
}, ms = {
  code: "en-US",
  formatDistance: Ha,
  formatLong: Ya,
  formatRelative: Ga,
  localize: nc,
  match: wc,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function _c(e) {
  const t = re(e);
  return hs(t, Fa(t)) + 1;
}
function vc(e) {
  const t = re(e), n = +Rt(t) - +Ia(t);
  return Math.round(n / us) + 1;
}
function ps(e, t) {
  var d, h, w, R;
  const n = re(e), r = n.getFullYear(), s = dt(), i = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((h = (d = t == null ? void 0 : t.locale) == null ? void 0 : d.options) == null ? void 0 : h.firstWeekContainsDate) ?? s.firstWeekContainsDate ?? ((R = (w = s.locale) == null ? void 0 : w.options) == null ? void 0 : R.firstWeekContainsDate) ?? 1, o = ke(e, 0);
  o.setFullYear(r + 1, 0, i), o.setHours(0, 0, 0, 0);
  const a = at(o, t), u = ke(e, 0);
  u.setFullYear(r, 0, i), u.setHours(0, 0, 0, 0);
  const l = at(u, t);
  return n.getTime() >= a.getTime() ? r + 1 : n.getTime() >= l.getTime() ? r : r - 1;
}
function bc(e, t) {
  var a, u, l, d;
  const n = dt(), r = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((u = (a = t == null ? void 0 : t.locale) == null ? void 0 : a.options) == null ? void 0 : u.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((d = (l = n.locale) == null ? void 0 : l.options) == null ? void 0 : d.firstWeekContainsDate) ?? 1, s = ps(e, t), i = ke(e, 0);
  return i.setFullYear(s, 0, r), i.setHours(0, 0, 0, 0), at(i, t);
}
function Tc(e, t) {
  const n = re(e), r = +at(n, t) - +bc(n, t);
  return Math.round(r / us) + 1;
}
function j(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const Ee = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return j(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : j(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return j(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return j(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return j(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return j(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return j(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), s = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return j(s, t.length);
  }
}, Be = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, nr = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), s = r > 0 ? r : 1 - r;
      return n.ordinalNumber(s, { unit: "year" });
    }
    return Ee.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const s = ps(e, r), i = s > 0 ? s : 1 - s;
    if (t === "YY") {
      const o = i % 100;
      return j(o, 2);
    }
    return t === "Yo" ? n.ordinalNumber(i, { unit: "year" }) : j(i, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = ds(e);
    return j(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return j(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(r);
      case "QQ":
        return j(r, 2);
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(r);
      case "qq":
        return j(r, 2);
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return Ee.M(e, t);
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "L":
        return String(r + 1);
      case "LL":
        return j(r + 1, 2);
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const s = Tc(e, r);
    return t === "wo" ? n.ordinalNumber(s, { unit: "week" }) : j(s, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = vc(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : j(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : Ee.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = _c(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : j(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const s = e.getDay(), i = (s - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(i);
      case "ee":
        return j(i, 2);
      case "eo":
        return n.ordinalNumber(i, { unit: "day" });
      case "eee":
        return n.day(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(s, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(s, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const s = e.getDay(), i = (s - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(i);
      case "cc":
        return j(i, t.length);
      case "co":
        return n.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return n.day(s, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(s, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(s, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(s, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), s = r === 0 ? 7 : r;
    switch (t) {
      case "i":
        return String(s);
      case "ii":
        return j(s, t.length);
      case "io":
        return n.ordinalNumber(s, { unit: "day" });
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const s = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let s;
    switch (r === 12 ? s = Be.noon : r === 0 ? s = Be.midnight : s = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let s;
    switch (r >= 17 ? s = Be.evening : r >= 12 ? s = Be.afternoon : r >= 4 ? s = Be.morning : s = Be.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return Ee.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : Ee.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : j(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : j(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Ee.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : Ee.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return Ee.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      case "X":
        return sr(r);
      case "XXXX":
      case "XX":
        return Ne(r);
      case "XXXXX":
      case "XXX":
      default:
        return Ne(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "x":
        return sr(r);
      case "xxxx":
      case "xx":
        return Ne(r);
      case "xxxxx":
      case "xxx":
      default:
        return Ne(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + rr(r, ":");
      case "OOOO":
      default:
        return "GMT" + Ne(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + rr(r, ":");
      case "zzzz":
      default:
        return "GMT" + Ne(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(e.getTime() / 1e3);
    return j(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    const r = e.getTime();
    return j(r, t.length);
  }
};
function rr(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), s = Math.trunc(r / 60), i = r % 60;
  return i === 0 ? n + String(s) : n + String(s) + t + j(i, 2);
}
function sr(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + j(Math.abs(e) / 60, 2) : Ne(e, t);
}
function Ne(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), s = j(Math.trunc(r / 60), 2), i = j(r % 60, 2);
  return n + s + t + i;
}
const ir = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, gs = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, Ec = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], s = n[2];
  if (!s)
    return ir(e, t);
  let i;
  switch (r) {
    case "P":
      i = t.dateTime({ width: "short" });
      break;
    case "PP":
      i = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = t.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", ir(r, t)).replace("{{time}}", gs(s, t));
}, Sc = {
  p: gs,
  P: Ec
}, Oc = /^D+$/, Cc = /^Y+$/, Rc = ["D", "DD", "YY", "YYYY"];
function kc(e) {
  return Oc.test(e);
}
function Ac(e) {
  return Cc.test(e);
}
function Pc(e, t, n) {
  const r = xc(e, t, n);
  if (console.warn(r), Rc.includes(e)) throw new RangeError(r);
}
function xc(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const Nc = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Lc = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Dc = /^'([^]*?)'?$/, Ic = /''/g, Mc = /[a-zA-Z]/;
function ys(e, t, n) {
  var d, h, w, R, _, b, O, P;
  const r = dt(), s = (n == null ? void 0 : n.locale) ?? r.locale ?? ms, i = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((h = (d = n == null ? void 0 : n.locale) == null ? void 0 : d.options) == null ? void 0 : h.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((R = (w = r.locale) == null ? void 0 : w.options) == null ? void 0 : R.firstWeekContainsDate) ?? 1, o = (n == null ? void 0 : n.weekStartsOn) ?? ((b = (_ = n == null ? void 0 : n.locale) == null ? void 0 : _.options) == null ? void 0 : b.weekStartsOn) ?? r.weekStartsOn ?? ((P = (O = r.locale) == null ? void 0 : O.options) == null ? void 0 : P.weekStartsOn) ?? 0, a = re(e);
  if (!Ua(a))
    throw new RangeError("Invalid time value");
  let u = t.match(Lc).map((A) => {
    const x = A[0];
    if (x === "p" || x === "P") {
      const W = Sc[x];
      return W(A, s.formatLong);
    }
    return A;
  }).join("").match(Nc).map((A) => {
    if (A === "''")
      return { isToken: !1, value: "'" };
    const x = A[0];
    if (x === "'")
      return { isToken: !1, value: jc(A) };
    if (nr[x])
      return { isToken: !0, value: A };
    if (x.match(Mc))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + x + "`"
      );
    return { isToken: !1, value: A };
  });
  s.localize.preprocessor && (u = s.localize.preprocessor(a, u));
  const l = {
    firstWeekContainsDate: i,
    weekStartsOn: o,
    locale: s
  };
  return u.map((A) => {
    if (!A.isToken) return A.value;
    const x = A.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && Ac(x) || !(n != null && n.useAdditionalDayOfYearTokens) && kc(x)) && Pc(x, t, String(e));
    const W = nr[x[0]];
    return W(a, x, s.localize, l);
  }).join("");
}
function jc(e) {
  const t = e.match(Dc);
  return t ? t[1].replace(Ic, "'") : e;
}
function $c(e, t, n) {
  var h, w;
  const r = re(e), s = re(t), i = dt(), o = i.locale ?? ms, a = i.weekStartsOn ?? ((w = (h = i.locale) == null ? void 0 : h.options) == null ? void 0 : w.weekStartsOn) ?? 0, u = hs(r, s);
  if (isNaN(u))
    throw new RangeError("Invalid time value");
  let l;
  u < -6 ? l = "other" : u < -1 ? l = "lastWeek" : u < 0 ? l = "yesterday" : u < 1 ? l = "today" : u < 2 ? l = "tomorrow" : u < 7 ? l = "nextWeek" : l = "other";
  const d = o.formatRelative(l, r, s, {
    locale: o,
    weekStartsOn: a
  });
  return ys(r, d, { locale: o, weekStartsOn: a });
}
function Uc(e) {
  return ja(e, Ma(e));
}
function Fc(e, t) {
  const r = Wc(e);
  let s;
  if (r.date) {
    const u = zc(r.date, 2);
    s = Yc(u.restDateString, u.year);
  }
  if (!s || isNaN(s.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  const i = s.getTime();
  let o = 0, a;
  if (r.time && (o = Vc(r.time), isNaN(o)))
    return /* @__PURE__ */ new Date(NaN);
  if (r.timezone) {
    if (a = Gc(r.timezone), isNaN(a))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    const u = new Date(i + o), l = /* @__PURE__ */ new Date(0);
    return l.setFullYear(
      u.getUTCFullYear(),
      u.getUTCMonth(),
      u.getUTCDate()
    ), l.setHours(
      u.getUTCHours(),
      u.getUTCMinutes(),
      u.getUTCSeconds(),
      u.getUTCMilliseconds()
    ), l;
  }
  return new Date(i + o + a);
}
const yt = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, Bc = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, Hc = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, qc = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function Wc(e) {
  const t = {}, n = e.split(yt.dateTimeDelimiter);
  let r;
  if (n.length > 2)
    return t;
  if (/:/.test(n[0]) ? r = n[0] : (t.date = n[0], r = n[1], yt.timeZoneDelimiter.test(t.date) && (t.date = e.split(yt.timeZoneDelimiter)[0], r = e.substr(
    t.date.length,
    e.length
  ))), r) {
    const s = yt.timezone.exec(r);
    s ? (t.time = r.replace(s[1], ""), t.timezone = s[1]) : t.time = r;
  }
  return t;
}
function zc(e, t) {
  const n = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + t) + "})|(\\d{2}|[+-]\\d{" + (2 + t) + "})$)"
  ), r = e.match(n);
  if (!r) return { year: NaN, restDateString: "" };
  const s = r[1] ? parseInt(r[1]) : null, i = r[2] ? parseInt(r[2]) : null;
  return {
    year: i === null ? s : i * 100,
    restDateString: e.slice((r[1] || r[2]).length)
  };
}
function Yc(e, t) {
  if (t === null) return /* @__PURE__ */ new Date(NaN);
  const n = e.match(Bc);
  if (!n) return /* @__PURE__ */ new Date(NaN);
  const r = !!n[4], s = Qe(n[1]), i = Qe(n[2]) - 1, o = Qe(n[3]), a = Qe(n[4]), u = Qe(n[5]) - 1;
  if (r)
    return Qc(t, a, u) ? Kc(t, a, u) : /* @__PURE__ */ new Date(NaN);
  {
    const l = /* @__PURE__ */ new Date(0);
    return !Xc(t, i, o) || !Zc(t, s) ? /* @__PURE__ */ new Date(NaN) : (l.setUTCFullYear(t, i, Math.max(s, o)), l);
  }
}
function Qe(e) {
  return e ? parseInt(e) : 1;
}
function Vc(e) {
  const t = e.match(Hc);
  if (!t) return NaN;
  const n = Zt(t[1]), r = Zt(t[2]), s = Zt(t[3]);
  return eu(n, r, s) ? n * fs + r * ls + s * 1e3 : NaN;
}
function Zt(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function Gc(e) {
  if (e === "Z") return 0;
  const t = e.match(qc);
  if (!t) return 0;
  const n = t[1] === "+" ? -1 : 1, r = parseInt(t[2]), s = t[3] && parseInt(t[3]) || 0;
  return tu(r, s) ? n * (r * fs + s * ls) : NaN;
}
function Kc(e, t, n) {
  const r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(e, 0, 4);
  const s = r.getUTCDay() || 7, i = (t - 1) * 7 + n + 1 - s;
  return r.setUTCDate(r.getUTCDate() + i), r;
}
const Jc = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function ws(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function Xc(e, t, n) {
  return t >= 0 && t <= 11 && n >= 1 && n <= (Jc[t] || (ws(e) ? 29 : 28));
}
function Zc(e, t) {
  return t >= 1 && t <= (ws(e) ? 366 : 365);
}
function Qc(e, t, n) {
  return t >= 1 && t <= 53 && n >= 0 && n <= 6;
}
function eu(e, t, n) {
  return e === 24 ? t === 0 && n === 0 : n >= 0 && n < 60 && t >= 0 && t < 60 && e >= 0 && e < 25;
}
function tu(e, t) {
  return t >= 0 && t <= 59;
}
function nu(e) {
  const t = Fc(e);
  if (Uc(t)) {
    const r = $c(t, /* @__PURE__ */ new Date());
    return r.charAt(0).toUpperCase() + r.slice(1);
  }
  return ys(t, "EEE, MMM d, yyyy 'at' h:mm aa");
}
const ru = ["width", "height"], su = /* @__PURE__ */ K({
  __name: "Envelope",
  props: {
    width: { default: 24 },
    height: { default: 24 }
  },
  setup(e) {
    const t = e;
    return (n, r) => (D(), q("svg", {
      width: t.width,
      viewBox: "0 0 20 20",
      fill: "none",
      height: t.height,
      xmlns: "http://www.w3.org/2000/svg"
    }, r[0] || (r[0] = [
      $("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M16.6665 4.99992H16.6665V4.99999L16.6665 4.99992ZM15.2775 4.99992H4.72203L9.99976 8.95821L15.2775 4.99992ZM3.33317 6.04161V14.9999H16.6665V6.04148L9.99976 11.0415L3.33317 6.04161ZM1.6665 4.99992C1.6665 4.07944 2.4127 3.33325 3.33317 3.33325H16.6665C17.587 3.33325 18.3332 4.07944 18.3332 4.99992V14.9999C18.3332 15.9204 17.587 16.6666 16.6665 16.6666H3.33317C2.4127 16.6666 1.6665 15.9204 1.6665 14.9999V4.99992Z",
        fill: "currentColor"
      }, null, -1)
    ]), 8, ru));
  }
}), iu = ["width", "height"], ou = /* @__PURE__ */ K({
  __name: "EnvelopeOpen",
  props: {
    width: { default: 24 },
    height: { default: 24 }
  },
  setup(e) {
    const t = e;
    return (n, r) => (D(), q("svg", {
      width: t.width,
      viewBox: "0 0 20 20",
      fill: "none",
      height: t.height,
      xmlns: "http://www.w3.org/2000/svg"
    }, r[0] || (r[0] = [
      $("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M16.6665 9.37498L16.6665 16.6667H3.33317V9.3751L9.99976 14.375L16.6665 9.37498ZM15.9243 7.8483L9.99984 3.70117L4.07529 7.84836L9.99976 12.2917L15.9243 7.8483ZM2.3774 7.00245L9.99984 1.66675L17.6223 7.00245C18.0678 7.31433 18.3332 7.82399 18.3332 8.36784V16.6667C18.3332 17.5872 17.587 18.3334 16.6665 18.3334H3.33317C2.4127 18.3334 1.6665 17.5872 1.6665 16.6667V8.36784C1.6665 7.82399 1.93186 7.31434 2.3774 7.00245Z",
        fill: "currentColor"
      }, null, -1)
    ]), 8, iu));
  }
}), au = ["width", "height"], cu = /* @__PURE__ */ K({
  __name: "OpenInNew",
  props: {
    width: { default: 24 },
    height: { default: 24 }
  },
  setup(e) {
    const t = e;
    return (n, r) => (D(), q("svg", {
      width: t.width,
      viewBox: "0 0 20 20",
      fill: "none",
      height: t.height,
      xmlns: "http://www.w3.org/2000/svg"
    }, r[0] || (r[0] = [
      $("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M15.8333 8.33333V5.29526L8.89702 12.2316L7.71851 11.0531L14.6049 4.16667H11.6667V2.5H15.8333L17.5 2.5L17.5 4.16667V8.33333H15.8333ZM15.8333 15.8333V10H17.5V15.8333C17.5 16.7538 16.7538 17.5 15.8333 17.5H4.16667C3.24619 17.5 2.5 16.7538 2.5 15.8333V4.16667C2.5 3.24619 3.24619 2.5 4.16667 2.5H10V4.16667L4.16667 4.16667L4.16667 15.8333H15.8333Z",
        fill: "currentColor"
      }, null, -1)
    ]), 8, au));
  }
}), uu = ["width", "height"], lu = /* @__PURE__ */ K({
  __name: "TrashCan",
  props: {
    width: { default: 24 },
    height: { default: 24 }
  },
  setup(e) {
    const t = e;
    return (n, r) => (D(), q("svg", {
      width: t.width,
      viewBox: "0 0 20 20",
      fill: "none",
      height: t.height,
      xmlns: "http://www.w3.org/2000/svg"
    }, r[0] || (r[0] = [
      $("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12.4997 1.66675H7.49967L6.66634 3.33341H3.33301V5.00008H16.6663V3.33341H13.333L12.4997 1.66675ZM14.1663 7.50008H5.83301L5.83301 16.6667H14.1663V7.50008ZM4.16634 5.83342V16.6667C4.16634 17.5872 4.91253 18.3334 5.83301 18.3334H14.1663C15.0868 18.3334 15.833 17.5872 15.833 16.6667V5.83342H4.16634ZM7.49967 9.16675H9.16634V15.0001H7.49967V9.16675ZM12.4997 9.16675H10.833V15.0001H12.4997V9.16675Z",
        fill: "currentColor"
      }, null, -1)
    ]), 8, uu));
  }
}), fu = {
  class: "vnf-notification-actions",
  "data-test": "vnf-notification-actions",
  tabindex: "0"
}, du = ["aria-label", "onKeydown"], hu = ["onKeydown"], mu = ["onKeydown"], pu = /* @__PURE__ */ K({
  __name: "NotificationActions",
  props: {
    feedClient: {},
    feedItem: {},
    url: {}
  },
  setup(e) {
    const t = e, { emitNotificationEvent: n } = Pe(), { data: r } = t.feedItem, { __meta: s, ...i } = r || {}, o = {
      notification_cta_url: s == null ? void 0 : s.cta_url,
      notification_id: t.feedItem.id,
      notification_status: s == null ? void 0 : s.status,
      notification_workflow: t.feedItem.source.key,
      ...i
    };
    async function a() {
      var w;
      await ((w = t.feedClient) == null ? void 0 : w.markAsRead(t.feedItem)), await n(V.NotificationMarkedAsRead, o);
    }
    async function u() {
      var w;
      await ((w = t.feedClient) == null ? void 0 : w.markAsUnread(t.feedItem)), await n(V.NotificationMarkedAsUnread, o);
    }
    async function l() {
      t.feedItem.read_at ? await u() : await a();
    }
    async function d() {
      await t.feedClient.markAsArchived(t.feedItem), await n(V.NotificationDeleted, o);
    }
    async function h() {
      t.feedItem.read_at || await a(), await n(V.NotificationOpenedInNewTab, o), window.open(t.url, "_blank");
    }
    return (w, R) => (D(), q("div", fu, [
      $("button", {
        icon: "",
        class: "vnf-notification-actions__item",
        "data-test": "vnf-notification-actions|mark-as-read-unread",
        "aria-label": `Mark notification as ${t.feedItem.read_at ? "Unread" : "Read"}`,
        onClick: R[0] || (R[0] = Z(() => {
        }, ["stop", "prevent"])),
        onMousedown: Z(l, ["stop", "prevent"]),
        onKeydown: Wt(Z(l, ["stop", "prevent"]), ["enter"]),
        onTouchend: Z(l, ["stop", "prevent"])
      }, [
        t.feedItem.read_at ? (D(), Re(su, {
          key: 1,
          "aria-hidden": "true"
        })) : (D(), Re(ou, {
          key: 0,
          "aria-hidden": "true"
        }))
      ], 40, du),
      $("button", {
        icon: "",
        class: "vnf-notification-actions__item",
        "data-test": "vnf-notification-actions|delete",
        "aria-label": "Delete notification",
        onClick: R[1] || (R[1] = Z(() => {
        }, ["stop", "prevent"])),
        onMousedown: Z(d, ["stop", "prevent"]),
        onKeydown: Wt(Z(d, ["stop", "prevent"]), ["enter"]),
        onTouchend: Z(d, ["stop", "prevent"])
      }, [
        te(lu, { "aria-hidden": "true" })
      ], 40, hu),
      $("button", {
        icon: "",
        class: "vnf-notification-actions__item",
        "data-test": "vnf-notification-actions|open-in-new-tab",
        "aria-label": "Open notification in new tab",
        onClick: R[2] || (R[2] = Z(() => {
        }, ["stop", "prevent"])),
        onMousedown: Z(h, ["stop", "prevent"]),
        onKeydown: Wt(Z(h, ["stop", "prevent"]), ["enter"]),
        onTouchend: Z(h, ["stop", "prevent"])
      }, [
        te(cu, { "aria-hidden": "true" })
      ], 40, mu)
    ]));
  }
}), _s = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, s] of t)
    n[r] = s;
  return n;
}, gu = /* @__PURE__ */ _s(pu, [["__scopeId", "data-v-9c62a779"]]), yu = ["href"], wu = { class: "vnf-notification-cell__inner" }, _u = {
  key: 0,
  "data-test": "vnf-notification-cell|unread-dot",
  class: "vnf-notification-cell__unread-dot"
}, vu = { class: "vnf-notification-cell__status" }, bu = { class: "vnf-notification-cell__content-outer" }, Tu = ["innerHTML"], Eu = {
  key: 1,
  class: "vnf-notification-cell__child-content"
}, Su = { class: "vnf-notification-cell__footer" }, Ou = {
  "data-test": "vnf-notification-cell|timestamp",
  class: "vnf-notification-cell__timestamp"
}, Cu = /* @__PURE__ */ K({
  __name: "NotificationCell",
  props: {
    feed: {},
    item: {},
    onItemClick: { type: Function }
  },
  setup(e) {
    const t = e, n = Hs(), { emitNotificationEvent: r } = Pe();
    let s;
    const i = Ar(Sn);
    if (t.feed)
      s = qe(t, "feed");
    else if (i)
      s = i.feedClient;
    else
      throw new Error("No feed client provided");
    const o = pe(
      () => t.item.blocks.reduce((_, b) => (_[b.name] = b, _), {})
    ), a = pe(() => {
      var _;
      return (_ = o.value.action_url) == null ? void 0 : _.rendered;
    }), u = async (_) => {
      const b = !!(_.metaKey || _.ctrlKey), { data: O } = t.item, { __meta: P, ...A } = O || {}, x = {
        notification_cta_url: P == null ? void 0 : P.cta_url,
        notification_id: t.item.id,
        notification_status: P == null ? void 0 : P.status,
        notification_workflow: t.item.source.key,
        toast_message: "No",
        ...A
      };
      if (await r(V.NotificationClicked, x), b ? await r(V.NotificationOpenedInNewTab, x) : _.preventDefault(), t.item.read_at || (await s.value.markAsRead(t.item), await r(V.NotificationMarkedAsRead, x)), t.onItemClick)
        return t.onItemClick(t.item);
      b || window.location.assign(a.value);
    }, l = pe(() => ({
      "vnf-notification-cell--read": !!t.item.read_at
    })), d = Object.freeze({
      error: ht(() => import("./CircleClose-Chq-MFBB.js")),
      warning: ht(() => import("./CircleWarning-CPjCAu_x.js")),
      info: ht(() => import("./CircleInfo-CFgNpll5.js")),
      success: ht(() => import("./CircleCheck-VKNzaorZ.js"))
    }), h = pe(() => {
      var _, b;
      return ((b = (_ = t.item.data) == null ? void 0 : _.__meta) == null ? void 0 : b.status) || "info";
    }), w = pe(() => h.value ? d[h.value] : null), R = pe(() => (o.value.body.rendered || "").replace(/\[TOAST\][\s\S]*?\[\/TOAST\]/g, ""));
    return (_, b) => (D(), q("a", {
      ref: "ref",
      class: Et(["vnf-notification-cell", l.value]),
      "data-test": "vnf-notification-cell",
      href: a.value,
      tabIndex: "0",
      onClick: u
    }, [
      $("div", wu, [
        _.item.read_at ? _t("", !0) : (D(), q("div", _u)),
        $("div", vu, [
          (D(), Re(qs(w.value), {
            class: Et({
              [`vnf-notification-cell__status--${h.value}`]: !!h.value
            })
          }, null, 8, ["class"]))
        ]),
        $("div", bu, [
          o.value.body ? (D(), q("div", {
            key: 0,
            "data-test": "vnf-notification-cell|content",
            class: "vnf-notification-cell__content",
            innerHTML: R.value
          }, null, 8, Tu)) : _t("", !0),
          Oe(n).default ? (D(), q("div", Eu, [
            wn(_.$slots, "default")
          ])) : _t("", !0)
        ]),
        $("div", Su, [
          $("span", Ou, _n(Oe(nu)(_.item.inserted_at)), 1),
          te(gu, {
            "feed-client": Oe(s),
            "feed-item": _.item,
            url: a.value
          }, null, 8, ["feed-client", "feed-item", "url"])
        ])
      ])
    ], 10, yu));
  }
}), Ru = { class: "vnf-notification-feed" }, ku = { class: "vnf-notification-feed__header" }, Au = { class: "vnf-notification-feed__header_copy" }, Pu = ["id"], xu = {
  key: 0,
  class: "vnf-notification-feed__container__loading"
}, Nu = {
  key: 1,
  class: "vnf-notification-feed__container__no_results"
}, Lu = /* @__PURE__ */ K({
  __name: "NotificationFeed",
  props: {
    initialFilterStatus: { default: He.All },
    settingsPath: { default: null }
  },
  setup(e) {
    const t = e, { feedClient: n, useFeedStore: r, emitNotificationEvent: s } = Pe(), i = se(), o = [He.All, He.Unread, He.Read], a = se(t.initialFilterStatus), u = r(), l = pe(() => u.items.length === 0);
    Ws(() => {
      var _;
      (_ = n.value) == null || _.fetch({ status: a.value });
    }), $e(
      a,
      (_, b) => {
        n.value && b && _ !== b && n.value.fetch({ status: _ });
      },
      { immediate: !0 }
    );
    const d = (_) => {
      if (!(_ !== He.Unread || !u.metadata.unread_count))
        return u.metadata.unread_count;
    }, h = (_) => {
      a.value = _;
      const b = `${_.charAt(0).toUpperCase() + _.slice(1)}TabClicked`;
      s(V[b]);
    }, w = () => {
      s(V.NotificationPreferencesClick, { access_point: "Gear Icon" });
    }, R = () => {
      var _;
      (_ = n.value) == null || _.markAllAsRead(), s(V.MarkAllAsReadClicked);
    };
    return (_, b) => (D(), q("div", Ru, [
      $("header", ku, [
        $("div", Au, [
          b[3] || (b[3] = $("span", { class: "vnf-notification-feed__title_text" }, "Notifications", -1)),
          t.settingsPath ? (D(), Re(Dn, {
            key: 0,
            href: t.settingsPath,
            icon: "",
            inline: "",
            class: "vnf-notification-feed__settings",
            title: "Settings",
            onClick: w
          }, {
            default: Le(() => [
              te(Vs, { name: "gear" })
            ]),
            _: 1
          }, 8, ["href"])) : _t("", !0),
          te(Dn, {
            class: "vnf-notification-feed__mark_all_as_read",
            inline: "",
            onClick: b[0] || (b[0] = (O) => R())
          }, {
            default: Le(() => b[2] || (b[2] = [
              mt(" Mark all as read ")
            ])),
            _: 1
          })
        ]),
        $("section", null, [
          te(Js, {
            "active-tab": a.value,
            "onUpdate:activeTab": b[1] || (b[1] = (O) => a.value = O),
            class: "vnf-notification-feed__nav"
          }, {
            default: Le(() => [
              (D(), q(nn, null, rn(o, (O) => te(Ks, {
                key: O,
                class: "vnf-tab-navigation__nav-item",
                value: O,
                badge: d(O),
                onClick: (P) => h(O)
              }, {
                default: Le(() => [
                  mt(_n(Oe(xa)[O]), 1)
                ]),
                _: 2
              }, 1032, ["value", "badge", "onClick"])), 64))
            ]),
            _: 1
          }, 8, ["active-tab"])
        ])
      ]),
      $("div", {
        id: `tabpanel-${a.value}`,
        ref_key: "containerRef",
        ref: i,
        class: "vnf-notification-feed__container",
        role: "tabpanel"
      }, [
        Oe(u).loading ? (D(), q("div", xu, [
          te(Gs)
        ])) : l.value ? (D(), q("div", Nu, b[4] || (b[4] = [
          $("div", { class: "vnf-notification-feed__container__no_results_container" }, [
            $("p", { class: "vnf-notification-feed__container__no_results_title" }, "No notifications yet"),
            $("p", { class: "vnf-notification-feed__container__no_results_body" }, [
              mt(" We'll let you know when we've got"),
              $("br"),
              mt(" something new for you. ")
            ])
          ], -1)
        ]))) : (D(!0), q(nn, { key: 2 }, rn(Oe(u).items || [], (O) => (D(), Re(Cu, {
          key: O.id,
          item: O
        }, null, 8, ["item"]))), 128))
      ], 8, Pu)
    ]));
  }
}), Du = { class: "vnf-notification-feed-popover__inner" }, qh = /* @__PURE__ */ K({
  __name: "NotificationFeedPopover",
  props: {
    isVisible: { type: Boolean, default: !1 },
    initialFilterStatus: {},
    settingsPath: {}
  },
  emits: ["close", "open"],
  setup(e, { emit: t }) {
    const { colorMode: n, feedClient: r, useFeedStore: s } = Pe(), i = s(), o = kr(), a = t, u = e;
    function l() {
      var d;
      if (o.onOpen)
        return a("open", { store: i, feedClient: r });
      i.metadata.unseen_count > 0 && ((d = r.value) == null || d.markAllAsSeen());
    }
    return $e([qe(u.isVisible), r], ([d]) => {
      d && r.value && l();
    }), (d, h) => (D(), q("div", {
      class: Et(["vnf-notification-feed-popover", `vnf-notification-feed-popover--${Oe(n)}`])
    }, [
      $("div", Du, [
        te(Lu, {
          "initial-filter-status": u.initialFilterStatus,
          "settings-path": u.settingsPath
        }, null, 8, ["initial-filter-status", "settings-path"])
      ])
    ], 2));
  }
}), Iu = ["width", "height"], Mu = /* @__PURE__ */ K({
  __name: "Bell",
  props: {
    width: { default: 24 },
    height: { default: 24 }
  },
  setup(e) {
    const t = e;
    return (n, r) => (D(), q("svg", {
      width: t.width,
      viewBox: "0 0 24 24",
      fill: "none",
      height: t.height,
      xmlns: "http://www.w3.org/2000/svg"
    }, r[0] || (r[0] = [
      $("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "M10 4a2 2 0 1 1 4 0v.341c2.33.824 4 3.047 4 5.659v3l2 3v3H4v-3l2-3v-3a6.002 6.002 0 0 1 4-5.659V4Zm4 16a2 2 0 1 1-4 0h4Zm2-7v.606l.336.503L18 16.606V17H6v-.394l1.664-2.497.336-.503V10a4 4 0 1 1 8 0v3Z",
        "clip-rule": "evenodd"
      }, null, -1)
    ]), 8, Iu));
  }
}), ju = /* @__PURE__ */ K({
  __name: "UnseenBadge",
  props: {
    badgeCountType: { default: "unread" }
  },
  setup(e) {
    const t = e, n = (o, a) => {
      if (!a)
        return 0;
      switch (o) {
        case "all":
          return a.total_count;
        case "unread":
          return a.unread_count;
        case "unseen":
          return a.unseen_count;
      }
    }, { useFeedStore: r } = Pe(), s = r(), i = pe(() => n(t.badgeCountType, s.metadata));
    return (o, a) => (D(), Re(Xs, {
      class: "vnf-unseen-badge",
      content: i.value,
      offset: { top: 6, right: 7 },
      animate: ""
    }, {
      default: Le(() => [
        wn(o.$slots, "default")
      ]),
      _: 3
    }, 8, ["content"]));
  }
}), Wh = /* @__PURE__ */ K({
  __name: "NotificationIconButton",
  props: {
    badgeCountType: { default: "unread" },
    isActive: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, { colorMode: n, emitNotificationEvent: r } = Pe(), s = () => {
      t.isActive ? r(V.NotificationsClosed) : r(V.NotificationsOpened);
    };
    return (i, o) => (D(), q("button", {
      class: Et(["vnf-notification-icon-button", [`vnf-notification-icon-button--${Oe(n)}`, { "vnf-notification-icon-button--active": i.isActive }]]),
      onClick: s
    }, [
      te(ju, {
        "badge-count-type": t.badgeCountType
      }, {
        default: Le(() => [
          te(Mu)
        ]),
        _: 1
      }, 8, ["badge-count-type"])
    ], 2));
  }
});
var vs = typeof global == "object" && global && global.Object === Object && global, $u = typeof self == "object" && self && self.Object === Object && self, we = vs || $u || Function("return this")(), Ae = we.Symbol, bs = Object.prototype, Uu = bs.hasOwnProperty, Fu = bs.toString, et = Ae ? Ae.toStringTag : void 0;
function Bu(e) {
  var t = Uu.call(e, et), n = e[et];
  try {
    e[et] = void 0;
    var r = !0;
  } catch {
  }
  var s = Fu.call(e);
  return r && (t ? e[et] = n : delete e[et]), s;
}
var Hu = Object.prototype, qu = Hu.toString;
function Wu(e) {
  return qu.call(e);
}
var zu = "[object Null]", Yu = "[object Undefined]", or = Ae ? Ae.toStringTag : void 0;
function Ve(e) {
  return e == null ? e === void 0 ? Yu : zu : or && or in Object(e) ? Bu(e) : Wu(e);
}
function On(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Vu = "[object AsyncFunction]", Gu = "[object Function]", Ku = "[object GeneratorFunction]", Ju = "[object Proxy]";
function Ts(e) {
  if (!On(e))
    return !1;
  var t = Ve(e);
  return t == Gu || t == Ku || t == Vu || t == Ju;
}
var Qt = we["__core-js_shared__"], ar = function() {
  var e = /[^.]+$/.exec(Qt && Qt.keys && Qt.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function Xu(e) {
  return !!ar && ar in e;
}
var Zu = Function.prototype, Qu = Zu.toString;
function Ue(e) {
  if (e != null) {
    try {
      return Qu.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var el = /[\\^$.*+?()[\]{}|]/g, tl = /^\[object .+?Constructor\]$/, nl = Function.prototype, rl = Object.prototype, sl = nl.toString, il = rl.hasOwnProperty, ol = RegExp(
  "^" + sl.call(il).replace(el, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function al(e) {
  if (!On(e) || Xu(e))
    return !1;
  var t = Ts(e) ? ol : tl;
  return t.test(Ue(e));
}
function cl(e, t) {
  return e == null ? void 0 : e[t];
}
function Fe(e, t) {
  var n = cl(e, t);
  return al(n) ? n : void 0;
}
var cr = function() {
  try {
    var e = Fe(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}();
function ul(e, t, n) {
  t == "__proto__" && cr ? cr(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
function ll(e, t, n, r) {
  for (var s = -1, i = e == null ? 0 : e.length; ++s < i; ) {
    var o = e[s];
    t(r, o, n(o), e);
  }
  return r;
}
function fl(e) {
  return function(t, n, r) {
    for (var s = -1, i = Object(t), o = r(t), a = o.length; a--; ) {
      var u = o[++s];
      if (n(i[u], u, i) === !1)
        break;
    }
    return t;
  };
}
var dl = fl();
function hl(e, t) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = t(n);
  return r;
}
function We(e) {
  return e != null && typeof e == "object";
}
var ml = "[object Arguments]";
function ur(e) {
  return We(e) && Ve(e) == ml;
}
var Es = Object.prototype, pl = Es.hasOwnProperty, gl = Es.propertyIsEnumerable, Ss = ur(/* @__PURE__ */ function() {
  return arguments;
}()) ? ur : function(e) {
  return We(e) && pl.call(e, "callee") && !gl.call(e, "callee");
}, fe = Array.isArray;
function yl() {
  return !1;
}
var Os = typeof exports == "object" && exports && !exports.nodeType && exports, lr = Os && typeof module == "object" && module && !module.nodeType && module, wl = lr && lr.exports === Os, fr = wl ? we.Buffer : void 0, _l = fr ? fr.isBuffer : void 0, hn = _l || yl, vl = 9007199254740991, bl = /^(?:0|[1-9]\d*)$/;
function Cs(e, t) {
  var n = typeof e;
  return t = t ?? vl, !!t && (n == "number" || n != "symbol" && bl.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var Tl = 9007199254740991;
function Cn(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Tl;
}
var El = "[object Arguments]", Sl = "[object Array]", Ol = "[object Boolean]", Cl = "[object Date]", Rl = "[object Error]", kl = "[object Function]", Al = "[object Map]", Pl = "[object Number]", xl = "[object Object]", Nl = "[object RegExp]", Ll = "[object Set]", Dl = "[object String]", Il = "[object WeakMap]", Ml = "[object ArrayBuffer]", jl = "[object DataView]", $l = "[object Float32Array]", Ul = "[object Float64Array]", Fl = "[object Int8Array]", Bl = "[object Int16Array]", Hl = "[object Int32Array]", ql = "[object Uint8Array]", Wl = "[object Uint8ClampedArray]", zl = "[object Uint16Array]", Yl = "[object Uint32Array]", U = {};
U[$l] = U[Ul] = U[Fl] = U[Bl] = U[Hl] = U[ql] = U[Wl] = U[zl] = U[Yl] = !0;
U[El] = U[Sl] = U[Ml] = U[Ol] = U[jl] = U[Cl] = U[Rl] = U[kl] = U[Al] = U[Pl] = U[xl] = U[Nl] = U[Ll] = U[Dl] = U[Il] = !1;
function Vl(e) {
  return We(e) && Cn(e.length) && !!U[Ve(e)];
}
function Gl(e) {
  return function(t) {
    return e(t);
  };
}
var Rs = typeof exports == "object" && exports && !exports.nodeType && exports, it = Rs && typeof module == "object" && module && !module.nodeType && module, Kl = it && it.exports === Rs, en = Kl && vs.process, dr = function() {
  try {
    var e = it && it.require && it.require("util").types;
    return e || en && en.binding && en.binding("util");
  } catch {
  }
}(), hr = dr && dr.isTypedArray, ks = hr ? Gl(hr) : Vl, Jl = Object.prototype, Xl = Jl.hasOwnProperty;
function Zl(e, t) {
  var n = fe(e), r = !n && Ss(e), s = !n && !r && hn(e), i = !n && !r && !s && ks(e), o = n || r || s || i, a = o ? hl(e.length, String) : [], u = a.length;
  for (var l in e)
    Xl.call(e, l) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (l == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    s && (l == "offset" || l == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (l == "buffer" || l == "byteLength" || l == "byteOffset") || // Skip index properties.
    Cs(l, u))) && a.push(l);
  return a;
}
var Ql = Object.prototype;
function ef(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || Ql;
  return e === n;
}
function tf(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var nf = tf(Object.keys, Object), rf = Object.prototype, sf = rf.hasOwnProperty;
function of(e) {
  if (!ef(e))
    return nf(e);
  var t = [];
  for (var n in Object(e))
    sf.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
function As(e) {
  return e != null && Cn(e.length) && !Ts(e);
}
function Rn(e) {
  return As(e) ? Zl(e) : of(e);
}
function af(e, t) {
  return e && dl(e, t, Rn);
}
function cf(e, t) {
  return function(n, r) {
    if (n == null)
      return n;
    if (!As(n))
      return e(n, r);
    for (var s = n.length, i = -1, o = Object(n); ++i < s && r(o[i], i, o) !== !1; )
      ;
    return n;
  };
}
var uf = cf(af);
function lf(e, t, n, r) {
  return uf(e, function(s, i, o) {
    t(r, s, n(s), o);
  }), r;
}
function ff() {
  this.__data__ = [], this.size = 0;
}
function Ps(e, t) {
  return e === t || e !== e && t !== t;
}
function Mt(e, t) {
  for (var n = e.length; n--; )
    if (Ps(e[n][0], t))
      return n;
  return -1;
}
var df = Array.prototype, hf = df.splice;
function mf(e) {
  var t = this.__data__, n = Mt(t, e);
  if (n < 0)
    return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : hf.call(t, n, 1), --this.size, !0;
}
function pf(e) {
  var t = this.__data__, n = Mt(t, e);
  return n < 0 ? void 0 : t[n][1];
}
function gf(e) {
  return Mt(this.__data__, e) > -1;
}
function yf(e, t) {
  var n = this.__data__, r = Mt(n, e);
  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
function _e(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
_e.prototype.clear = ff;
_e.prototype.delete = mf;
_e.prototype.get = pf;
_e.prototype.has = gf;
_e.prototype.set = yf;
function wf() {
  this.__data__ = new _e(), this.size = 0;
}
function _f(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
function vf(e) {
  return this.__data__.get(e);
}
function bf(e) {
  return this.__data__.has(e);
}
var ct = Fe(we, "Map"), ut = Fe(Object, "create");
function Tf() {
  this.__data__ = ut ? ut(null) : {}, this.size = 0;
}
function Ef(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var Sf = "__lodash_hash_undefined__", Of = Object.prototype, Cf = Of.hasOwnProperty;
function Rf(e) {
  var t = this.__data__;
  if (ut) {
    var n = t[e];
    return n === Sf ? void 0 : n;
  }
  return Cf.call(t, e) ? t[e] : void 0;
}
var kf = Object.prototype, Af = kf.hasOwnProperty;
function Pf(e) {
  var t = this.__data__;
  return ut ? t[e] !== void 0 : Af.call(t, e);
}
var xf = "__lodash_hash_undefined__";
function Nf(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = ut && t === void 0 ? xf : t, this;
}
function je(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
je.prototype.clear = Tf;
je.prototype.delete = Ef;
je.prototype.get = Rf;
je.prototype.has = Pf;
je.prototype.set = Nf;
function Lf() {
  this.size = 0, this.__data__ = {
    hash: new je(),
    map: new (ct || _e)(),
    string: new je()
  };
}
function Df(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function jt(e, t) {
  var n = e.__data__;
  return Df(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
function If(e) {
  var t = jt(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function Mf(e) {
  return jt(this, e).get(e);
}
function jf(e) {
  return jt(this, e).has(e);
}
function $f(e, t) {
  var n = jt(this, e), r = n.size;
  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
function ve(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
ve.prototype.clear = Lf;
ve.prototype.delete = If;
ve.prototype.get = Mf;
ve.prototype.has = jf;
ve.prototype.set = $f;
var Uf = 200;
function Ff(e, t) {
  var n = this.__data__;
  if (n instanceof _e) {
    var r = n.__data__;
    if (!ct || r.length < Uf - 1)
      return r.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new ve(r);
  }
  return n.set(e, t), this.size = n.size, this;
}
function ye(e) {
  var t = this.__data__ = new _e(e);
  this.size = t.size;
}
ye.prototype.clear = wf;
ye.prototype.delete = _f;
ye.prototype.get = vf;
ye.prototype.has = bf;
ye.prototype.set = Ff;
var Bf = "__lodash_hash_undefined__";
function Hf(e) {
  return this.__data__.set(e, Bf), this;
}
function qf(e) {
  return this.__data__.has(e);
}
function At(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new ve(); ++t < n; )
    this.add(e[t]);
}
At.prototype.add = At.prototype.push = Hf;
At.prototype.has = qf;
function Wf(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r; )
    if (t(e[n], n, e))
      return !0;
  return !1;
}
function zf(e, t) {
  return e.has(t);
}
var Yf = 1, Vf = 2;
function xs(e, t, n, r, s, i) {
  var o = n & Yf, a = e.length, u = t.length;
  if (a != u && !(o && u > a))
    return !1;
  var l = i.get(e), d = i.get(t);
  if (l && d)
    return l == t && d == e;
  var h = -1, w = !0, R = n & Vf ? new At() : void 0;
  for (i.set(e, t), i.set(t, e); ++h < a; ) {
    var _ = e[h], b = t[h];
    if (r)
      var O = o ? r(b, _, h, t, e, i) : r(_, b, h, e, t, i);
    if (O !== void 0) {
      if (O)
        continue;
      w = !1;
      break;
    }
    if (R) {
      if (!Wf(t, function(P, A) {
        if (!zf(R, A) && (_ === P || s(_, P, n, r, i)))
          return R.push(A);
      })) {
        w = !1;
        break;
      }
    } else if (!(_ === b || s(_, b, n, r, i))) {
      w = !1;
      break;
    }
  }
  return i.delete(e), i.delete(t), w;
}
var mr = we.Uint8Array;
function Gf(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r, s) {
    n[++t] = [s, r];
  }), n;
}
function Kf(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r) {
    n[++t] = r;
  }), n;
}
var Jf = 1, Xf = 2, Zf = "[object Boolean]", Qf = "[object Date]", ed = "[object Error]", td = "[object Map]", nd = "[object Number]", rd = "[object RegExp]", sd = "[object Set]", id = "[object String]", od = "[object Symbol]", ad = "[object ArrayBuffer]", cd = "[object DataView]", pr = Ae ? Ae.prototype : void 0, tn = pr ? pr.valueOf : void 0;
function ud(e, t, n, r, s, i, o) {
  switch (n) {
    case cd:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case ad:
      return !(e.byteLength != t.byteLength || !i(new mr(e), new mr(t)));
    case Zf:
    case Qf:
    case nd:
      return Ps(+e, +t);
    case ed:
      return e.name == t.name && e.message == t.message;
    case rd:
    case id:
      return e == t + "";
    case td:
      var a = Gf;
    case sd:
      var u = r & Jf;
      if (a || (a = Kf), e.size != t.size && !u)
        return !1;
      var l = o.get(e);
      if (l)
        return l == t;
      r |= Xf, o.set(e, t);
      var d = xs(a(e), a(t), r, s, i, o);
      return o.delete(e), d;
    case od:
      if (tn)
        return tn.call(e) == tn.call(t);
  }
  return !1;
}
function ld(e, t) {
  for (var n = -1, r = t.length, s = e.length; ++n < r; )
    e[s + n] = t[n];
  return e;
}
function fd(e, t, n) {
  var r = t(e);
  return fe(e) ? r : ld(r, n(e));
}
function dd(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, s = 0, i = []; ++n < r; ) {
    var o = e[n];
    t(o, n, e) && (i[s++] = o);
  }
  return i;
}
function hd() {
  return [];
}
var md = Object.prototype, pd = md.propertyIsEnumerable, gr = Object.getOwnPropertySymbols, gd = gr ? function(e) {
  return e == null ? [] : (e = Object(e), dd(gr(e), function(t) {
    return pd.call(e, t);
  }));
} : hd;
function yr(e) {
  return fd(e, Rn, gd);
}
var yd = 1, wd = Object.prototype, _d = wd.hasOwnProperty;
function vd(e, t, n, r, s, i) {
  var o = n & yd, a = yr(e), u = a.length, l = yr(t), d = l.length;
  if (u != d && !o)
    return !1;
  for (var h = u; h--; ) {
    var w = a[h];
    if (!(o ? w in t : _d.call(t, w)))
      return !1;
  }
  var R = i.get(e), _ = i.get(t);
  if (R && _)
    return R == t && _ == e;
  var b = !0;
  i.set(e, t), i.set(t, e);
  for (var O = o; ++h < u; ) {
    w = a[h];
    var P = e[w], A = t[w];
    if (r)
      var x = o ? r(A, P, w, t, e, i) : r(P, A, w, e, t, i);
    if (!(x === void 0 ? P === A || s(P, A, n, r, i) : x)) {
      b = !1;
      break;
    }
    O || (O = w == "constructor");
  }
  if (b && !O) {
    var W = e.constructor, F = t.constructor;
    W != F && "constructor" in e && "constructor" in t && !(typeof W == "function" && W instanceof W && typeof F == "function" && F instanceof F) && (b = !1);
  }
  return i.delete(e), i.delete(t), b;
}
var mn = Fe(we, "DataView"), pn = Fe(we, "Promise"), gn = Fe(we, "Set"), yn = Fe(we, "WeakMap"), wr = "[object Map]", bd = "[object Object]", _r = "[object Promise]", vr = "[object Set]", br = "[object WeakMap]", Tr = "[object DataView]", Td = Ue(mn), Ed = Ue(ct), Sd = Ue(pn), Od = Ue(gn), Cd = Ue(yn), Se = Ve;
(mn && Se(new mn(new ArrayBuffer(1))) != Tr || ct && Se(new ct()) != wr || pn && Se(pn.resolve()) != _r || gn && Se(new gn()) != vr || yn && Se(new yn()) != br) && (Se = function(e) {
  var t = Ve(e), n = t == bd ? e.constructor : void 0, r = n ? Ue(n) : "";
  if (r)
    switch (r) {
      case Td:
        return Tr;
      case Ed:
        return wr;
      case Sd:
        return _r;
      case Od:
        return vr;
      case Cd:
        return br;
    }
  return t;
});
var Rd = 1, Er = "[object Arguments]", Sr = "[object Array]", wt = "[object Object]", kd = Object.prototype, Or = kd.hasOwnProperty;
function Ad(e, t, n, r, s, i) {
  var o = fe(e), a = fe(t), u = o ? Sr : Se(e), l = a ? Sr : Se(t);
  u = u == Er ? wt : u, l = l == Er ? wt : l;
  var d = u == wt, h = l == wt, w = u == l;
  if (w && hn(e)) {
    if (!hn(t))
      return !1;
    o = !0, d = !1;
  }
  if (w && !d)
    return i || (i = new ye()), o || ks(e) ? xs(e, t, n, r, s, i) : ud(e, t, u, n, r, s, i);
  if (!(n & Rd)) {
    var R = d && Or.call(e, "__wrapped__"), _ = h && Or.call(t, "__wrapped__");
    if (R || _) {
      var b = R ? e.value() : e, O = _ ? t.value() : t;
      return i || (i = new ye()), s(b, O, n, r, i);
    }
  }
  return w ? (i || (i = new ye()), vd(e, t, n, r, s, i)) : !1;
}
function kn(e, t, n, r, s) {
  return e === t ? !0 : e == null || t == null || !We(e) && !We(t) ? e !== e && t !== t : Ad(e, t, n, r, kn, s);
}
var Pd = 1, xd = 2;
function Nd(e, t, n, r) {
  var s = n.length, i = s;
  if (e == null)
    return !i;
  for (e = Object(e); s--; ) {
    var o = n[s];
    if (o[2] ? o[1] !== e[o[0]] : !(o[0] in e))
      return !1;
  }
  for (; ++s < i; ) {
    o = n[s];
    var a = o[0], u = e[a], l = o[1];
    if (o[2]) {
      if (u === void 0 && !(a in e))
        return !1;
    } else {
      var d = new ye(), h;
      if (!(h === void 0 ? kn(l, u, Pd | xd, r, d) : h))
        return !1;
    }
  }
  return !0;
}
function Ns(e) {
  return e === e && !On(e);
}
function Ld(e) {
  for (var t = Rn(e), n = t.length; n--; ) {
    var r = t[n], s = e[r];
    t[n] = [r, s, Ns(s)];
  }
  return t;
}
function Ls(e, t) {
  return function(n) {
    return n == null ? !1 : n[e] === t && (t !== void 0 || e in Object(n));
  };
}
function Dd(e) {
  var t = Ld(e);
  return t.length == 1 && t[0][2] ? Ls(t[0][0], t[0][1]) : function(n) {
    return n === e || Nd(n, e, t);
  };
}
var Id = "[object Symbol]";
function An(e) {
  return typeof e == "symbol" || We(e) && Ve(e) == Id;
}
var Md = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, jd = /^\w*$/;
function Pn(e, t) {
  if (fe(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || An(e) ? !0 : jd.test(e) || !Md.test(e) || t != null && e in Object(t);
}
var $d = "Expected a function";
function xn(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError($d);
  var n = function() {
    var r = arguments, s = t ? t.apply(this, r) : r[0], i = n.cache;
    if (i.has(s))
      return i.get(s);
    var o = e.apply(this, r);
    return n.cache = i.set(s, o) || i, o;
  };
  return n.cache = new (xn.Cache || ve)(), n;
}
xn.Cache = ve;
var Ud = 500;
function Fd(e) {
  var t = xn(e, function(r) {
    return n.size === Ud && n.clear(), r;
  }), n = t.cache;
  return t;
}
var Bd = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Hd = /\\(\\)?/g, qd = Fd(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(Bd, function(n, r, s, i) {
    t.push(s ? i.replace(Hd, "$1") : r || n);
  }), t;
});
function Wd(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, s = Array(r); ++n < r; )
    s[n] = t(e[n], n, e);
  return s;
}
var Cr = Ae ? Ae.prototype : void 0, Rr = Cr ? Cr.toString : void 0;
function Ds(e) {
  if (typeof e == "string")
    return e;
  if (fe(e))
    return Wd(e, Ds) + "";
  if (An(e))
    return Rr ? Rr.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
function zd(e) {
  return e == null ? "" : Ds(e);
}
function Is(e, t) {
  return fe(e) ? e : Pn(e, t) ? [e] : qd(zd(e));
}
function $t(e) {
  if (typeof e == "string" || An(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
function Ms(e, t) {
  t = Is(t, e);
  for (var n = 0, r = t.length; e != null && n < r; )
    e = e[$t(t[n++])];
  return n && n == r ? e : void 0;
}
function Yd(e, t, n) {
  var r = e == null ? void 0 : Ms(e, t);
  return r === void 0 ? n : r;
}
function Vd(e, t) {
  return e != null && t in Object(e);
}
function Gd(e, t, n) {
  t = Is(t, e);
  for (var r = -1, s = t.length, i = !1; ++r < s; ) {
    var o = $t(t[r]);
    if (!(i = e != null && n(e, o)))
      break;
    e = e[o];
  }
  return i || ++r != s ? i : (s = e == null ? 0 : e.length, !!s && Cn(s) && Cs(o, s) && (fe(e) || Ss(e)));
}
function Kd(e, t) {
  return e != null && Gd(e, t, Vd);
}
var Jd = 1, Xd = 2;
function Zd(e, t) {
  return Pn(e) && Ns(t) ? Ls($t(e), t) : function(n) {
    var r = Yd(n, e);
    return r === void 0 && r === t ? Kd(n, e) : kn(t, r, Jd | Xd);
  };
}
function Qd(e) {
  return e;
}
function eh(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
function th(e) {
  return function(t) {
    return Ms(t, e);
  };
}
function nh(e) {
  return Pn(e) ? eh($t(e)) : th(e);
}
function rh(e) {
  return typeof e == "function" ? e : e == null ? Qd : typeof e == "object" ? fe(e) ? Zd(e[0], e[1]) : Dd(e) : nh(e);
}
function sh(e, t) {
  return function(n, r) {
    var s = fe(n) ? ll : lf, i = {};
    return s(n, e, rh(r), i);
  };
}
var ih = sh(function(e, t, n) {
  ul(e, n, t);
});
const oh = ["width", "height"], ah = /* @__PURE__ */ K({
  __name: "CircleCheck",
  props: {
    width: { default: 24 },
    height: { default: 24 }
  },
  setup(e) {
    const t = e;
    return (n, r) => (D(), q("svg", {
      width: t.width,
      viewBox: "0 0 24 24",
      fill: "none",
      height: t.height,
      xmlns: "http://www.w3.org/2000/svg"
    }, r[0] || (r[0] = [
      $("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM7 12.1373L10.9926 15.7531L16.7979 9.34252L15.3155 8L10.8526 12.928L8.34252 10.6549L7 12.1373Z",
        "clip-rule": "evenodd"
      }, null, -1)
    ]), 8, oh));
  }
}), ch = ["width", "height"], uh = /* @__PURE__ */ K({
  __name: "Close",
  props: {
    width: { default: 24 },
    height: { default: 24 }
  },
  setup(e) {
    const t = e;
    return (n, r) => (D(), q("svg", {
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, r[0] || (r[0] = [
      $("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M16.95 18.3642L18.3643 16.9499L13.4145 12.0002L18.3642 7.05045L16.95 5.63623L12.0003 10.586L7.05055 5.63623L5.63633 7.05045L10.5861 12.0002L5.63632 16.9499L7.05054 18.3642L12.0003 13.4144L16.95 18.3642Z"
      }, null, -1)
    ]), 8, ch));
  }
}), lh = { class: "tw-flex tw-w-full tw-items-center tw-gap-3 tw-px-[18px]" }, fh = { class: "tw-w-full tw-text-sm tw-font-semibold" }, dh = ["innerHTML"], hh = /* @__PURE__ */ K({
  __name: "NotificationToast",
  props: {
    id: {},
    title: {},
    text: {},
    item: {}
  },
  emits: ["close", "open"],
  setup(e, { emit: t }) {
    const n = e, r = se(!1), s = t, { feedClient: i, emitNotificationEvent: o } = Pe(), a = pe(() => {
      if (!n.item)
        return n.text;
      const h = ih(n.item.blocks, "name").body.rendered;
      let [, w] = h.match(/\[TOAST\](.*)\[\/TOAST\]/s) || [];
      return w ? w = w.replace(/\[\/?TOAST\]/g, "") : w = h.replace(/<blockquote>.*<\/blockquote>/s, ""), w;
    }), u = async (d) => {
      if (!i.value || r.value)
        return;
      if (setTimeout(() => {
        s("close", d);
      }, Pa), !n.item) {
        const O = document.querySelector(".vnf-notification-icon-button");
        O == null || O.dispatchEvent(new MouseEvent("click"));
        return;
      }
      const { data: h } = n.item, { __meta: w, ...R } = h || {};
      if (!w)
        return;
      const _ = d.metaKey || d.ctrlKey, b = {
        notification_cta_url: w.cta_url,
        notification_id: n.item.id,
        notification_status: w.status,
        notification_workflow: n.item.source.key,
        toast_message: "Yes",
        ...R
      };
      o(V.NotificationClicked, b), !_ && w ? (d.preventDefault(), window.location.assign(w.cta_url)) : (o(V.NotificationOpenedInNewTab, b), window.open(w.cta_url, "_blank")), n.item.read_at || (await i.value.markAsRead(n.item), o(V.NotificationMarkedAsRead, b));
    }, l = (d) => {
      if (!n.item)
        return s("close", d);
      r.value = !0;
      const { data: h } = n.item, { __meta: w, ...R } = h || {};
      if (!w)
        return;
      const _ = {
        notification_cta_url: w.cta_url,
        notification_id: n.item.id,
        notification_status: w.status,
        notification_workflow: n.item.source.key,
        toast_message: "Yes",
        ...R
      };
      o(V.NotificationDismissed, _), s("close", d);
    };
    return (d, h) => (D(), q("li", {
      "data-test": "vnf-notification-toast",
      class: "vnf-toast",
      onClick: h[0] || (h[0] = Z((w) => u(w), ["stop"]))
    }, [
      $("div", lh, [
        te(ah, {
          class: "vnf-toast-icon",
          width: 32,
          height: 32
        }),
        $("h3", fh, _n(n.title), 1),
        te(uh, {
          class: "vnf-toast-close",
          width: 32,
          height: 32,
          onClick: Z(l, ["stop"])
        })
      ]),
      $("div", {
        class: "vnf-toast-content",
        innerHTML: a.value
      }, null, 8, dh)
    ]));
  }
}), mh = /* @__PURE__ */ K({
  __name: "NotificationToaster",
  setup(e) {
    const { feedClient: t, useFeedStore: n } = Pe(), r = n(), s = se([]), i = se(!1);
    $e(
      r,
      (d) => {
        d.networkStatus === "ready" && !i.value && o();
      },
      { immediate: !0, deep: !0 }
    );
    const o = () => {
      var h, w;
      i.value = !0;
      const d = (h = r.metadata) == null ? void 0 : h.unread_count;
      if (d > 1) {
        const R = `You have <strong>${d} new notifications</strong>`;
        l({
          id: Math.random().toString(36).substr(2, 9),
          title: "New notifications",
          text: R
        });
      } else if (d === 1) {
        const R = r.items.find((_) => !_.read_at);
        R && l({
          id: R.id,
          title: "New notification received",
          item: R
        });
      }
      (w = t.value) == null || w.on("items.received.realtime", a);
    }, a = (d) => {
      for (const h of d.items)
        l({
          id: h.id,
          title: "New notification received",
          item: h
        });
    }, u = (d) => {
      const h = s.value.findIndex((w) => w.id === d);
      ~h && s.value.splice(h, 1);
    }, l = (d) => {
      s.value.push(d), setTimeout(() => {
        u(d.id);
      }, Aa);
    };
    return zs(() => {
      var d;
      t.value && ((d = t.value) == null || d.off("items.received.realtime", a));
    }), (d, h) => (D(), Re(Ys, {
      "aria-atomic": "true",
      "aria-live": "polite",
      name: "toasts",
      tag: "ul",
      class: "vnf-toaster"
    }, {
      default: Le(() => [
        (D(!0), q(nn, null, rn(s.value, (w) => (D(), Re(hh, {
          id: w.id,
          key: w.id,
          text: w.text,
          title: w.title,
          item: w.item,
          onClose: (R) => u(w.id)
        }, null, 8, ["id", "text", "title", "item", "onClose"]))), 128))
      ]),
      _: 1
    }));
  }
}), zh = /* @__PURE__ */ _s(mh, [["__scopeId", "data-v-a8b50762"]]);
function Yh(e) {
  const t = se(), n = se(!1);
  async function r() {
    if (!e.value)
      return;
    const s = e.value.knock, i = s.client(), o = `/v1/users/${s.userId}/feeds/${e.value.feedId}/settings`;
    n.value = !0;
    const a = await i.makeRequest({
      method: "GET",
      url: o
    });
    a.error || (t.value = a.body), n.value = !1;
  }
  return $e(e, r, { immediate: !0 }), { settings: t, loading: n };
}
export {
  Aa as D,
  V as E,
  He as F,
  Sn as K,
  zh as N,
  Pa as T,
  ah as _,
  Hh as a,
  Cu as b,
  Lu as c,
  qh as d,
  Wh as e,
  hh as f,
  ju as g,
  Yh as h,
  ka as i,
  xa as j,
  Ra as u
};
